// Global Style vars
var FONT_FAMILY = 'AvenirNext, Helvetica, Arial, sans-serif';
var RENTVISION_STILLWATER = '#5c6670';
var RENTVISION_CLOUD = '#cac8c8';
var CHART_FONT_SIZE_LARGE = 16;
var CHART_FONT_SIZE_MEDIUM = 14;
var CHART_FONT_SIZE_SMALL = 12;
var TOOLTIP_DELAY = 500;

// Google Visualization (Chart) Style vars
var CHART_SHARED_CONFIG = {
    width: '100%',
    fontName: FONT_FAMILY,
    fontSize: CHART_FONT_SIZE_SMALL,
    fontWeight: 300
};

var CHART_ANNOTATIONS = {
    annotations: {
        style: 'line',
        textStyle: {
            color: RENTVISION_STILLWATER,
            opacity: 0.3
        }
    }
};

var CHART_TOOLTIP = {
    tooltip: {
        textStyle: {
            color: RENTVISION_STILLWATER
        }
    }
};

var CHART_LARGE_H_AXIS = {
    hAxis: {
        textStyle: {
            color: RENTVISION_STILLWATER,
            fontSize: CHART_FONT_SIZE_MEDIUM
        },
        slantedText: false,
        maxAlternation: 1,
        maxTextLines: 1
    }
};

var CHART_LARGE_LEGEND = {
    legend: {
        position: 'bottom',
        textStyle: {
            color: RENTVISION_STILLWATER,
            fontSize: CHART_FONT_SIZE_MEDIUM
        }
    }
};

var CHART_LARGE_AREA = {
    chartArea: {
        width: '95%',
        left: '5%',
        height: '75%',
        top: '5%'
    }
};

var GRIDLINE_COLOR = '#eaeaea';

// "Global" state object for page instance.
var rvpPageState = {
    // Keep track if there has been a form change to check in window.onbeforeunload so the user
    // can be alerted if navigating away from a page with potentially unsubmitted changes.
    hasFormChange: false,
};

/** "Create" a new popup by replacing the content of the existing popup (if one is open).
 *
 * @param text: HTML-tagged text to be placed into the popup
 */
function magnific(text) {
    $.magnificPopup.open({
        items: {
            src: '<div class="white-popup">' + text + '</div>'
        },
        type: 'inline'
    }, 0);
}


function trackEvent(category, action, label) {
    try {
        if (ga) {
            ga('send', 'event', category, action, label);
        }
    } catch (err) {
        //ignore
    }
}

function trackGA4Event(eventType, parameters = {}) {
    try {
        gtag('event', eventType, parameters);
    } catch (err) {
        //ignore, GA4 not set up
    }
}

function triggerContactLoadingScrollCheck() {
    $('.emailListing .listing-wrapper').scroll();
}

function validateUserUpdateForm() {
    if ($.trim($('#firstName').val()) == '' || $.trim($('#lastName').val()) == '' || $.trim($('#email').val()) == '') {
        alert('Please enter all required fields.');
        return false;
    }
    if (!isEmailValid($('#email').val())) {
        alert('Invalid email address.');
        return false;
    }
    return true;
}

function validatePasswordForm(showAlert = true) {
    if ($('#password').val() == '' || $('#passwordConfirm').val() == '') {
        if (showAlert) {
            alert('Please enter all required fields.');
        }
        return 'MISSING_FIELD';
    }
    var pre = /(?=.*?[0-9])(?=.*?[A-Z]).*?[a-z].*/;
    if ($('#password').val().length < 6 || !pre.test($('#password').val())) {
        if (showAlert) {
            alert('Password is too weak, try another one.  Needs to be more than 5 characters and contain 1 lowercase letter, 1 uppercase letter, and 1 number.');
        }
        return 'WEAK_PASSWORD';
    }
    if ($('#password').val() != $('#passwordConfirm').val()) {
        if (showAlert) {
            alert('Passwords do not match.');
        }
        return 'MISMATCHING_PASSWORD';
    }
    return null;
}

function validateDeposit() {
    if ($('#depositInDollars').val() == '' && $('#deposit').val() == '') {
        alert('Please enter a value for \'Deposit\' or \'Custom Deposit\'.');
        $('#depositInDollars').focus();
        return false;
    } else if ($('#depositInDollars').val() != '' && $('#deposit').val() != '') {
        alert('Please enter a value for \'Deposit\' or \'Custom Deposit\', but not both.');
        $('#depositInDollars').focus();
        return false;
    }
    return true;
}

function initSelect2() {
    $('select').each(function () {
        if (!$(this).hasClass('no-select2')) {
            $(this).select2({dropdownAutoWidth: true, width: 'auto'});
        }
    });

    // add tooltip here.  Must set a delay as select2 is not ready to call tooltip if called too quickly
    setTimeout(function () {
        $('select.no-delay ~ span .select2-selection__rendered').tooltip({
            position: {at: 'right center'}
        });
        $('select:not(.no-delay) ~ span .select2-selection__rendered').tooltip({
            show: {delay: TOOLTIP_DELAY},
            position: {at: 'right center'}
        });
    }, 250);
}

function floorplanSearch(searchInput, clearButton, navContainer) {
    var searchValue = $.trim($(searchInput).val()).toLowerCase();
    if (searchValue == '') {
        $(navContainer + ' > .nav-item-section').show();
        $(navContainer + ' > .nav-item-section a').show();
        $(clearButton).hide();
        $('.floorplan').show();
        $('.noMatch').hide();
    } else {
        var lastTierOne = null;
        $(navContainer + ' > .nav-item-section a').each(function () {
            var isTierOne = false;
            if ($(this).hasClass('tierOne')) {
                lastTierOne = this;
                isTierOne = true;
            }
            if ($(this).text().toLowerCase().indexOf(searchValue) != -1) {
                if (isTierOne) {
                    $(this).parent().show();
                } else {
                    $(this).show();
                }
                if ($(this).hasClass('tierTwo')) {
                    $(lastTierOne).parent().show();
                }
            } else if (isTierOne) {
                $(this).parent().hide();
            } else {
                $(this).hide();
            }
        });
        $(clearButton).show();
        showFloorplans(navContainer);
    }
    $(searchInput).focus();
}

function clearFloorplanSearch(searchInput, clearButton, navContainer) {
    $(searchInput).val('');
    $(navContainer + ' > .nav-item-section').show();
    $(navContainer + ' > .nav-item-section a').show();
    $(clearButton).hide();
    $(searchInput).focus();
    $('.floorplan').show();
    $('.noMatch').hide();
}

function floorplanSearchDB(searchInput, clearButton, navContainer) {
    var searchValue = $.trim($(searchInput).val()).toLowerCase();
    $(navContainer + ' .nav-item-section').each(function () {
        $(this).remove();
    });
    if (searchValue == '') {
        clearFloorplanSearchDB(searchInput, clearButton, navContainer);
    } else {
        $(clearButton).show();
        var request = $.ajax({
            url: '/rapi/rvp/user/search-user-applications?s=' + encodeURIComponent(searchValue) + '&af=true',
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            var applications = msg['a'];
            var floorplanMap = msg['b'];
            for (var i = 0; i < applications.length; i++) {
                var application = applications[i];
                var html = '';
                if (application['applicationType'] == 'COMMUNITY') {
                    html += '<div class="nav-item-section">';
                    html += '<a id="communityNav' + application['applicationId'] + '" class="tierOne" href="community-details?a=';
                    html += application['applicationId'];
                    html += '">';
                    html += application['serverName'];
                    html += '</a>';
                    var floorplans = floorplanMap[application['applicationId']];
                    if (floorplans) {
                        for (var j = 0; j < floorplans.length; j++) {
                            var floorplan = floorplans[j];
                            html += '<a id="floorplanNav' + floorplan['floorplanId'] + '" class="tierTwo" href="floorplan-details?a=';
                            html += application['applicationId'];
                            html += '&f=';
                            html += floorplan['floorplanId'];
                            html += '">';
                            html += floorplan['title'];
                            html += '</a>';
                        }
                    }
                    html += '</div>';
                } else if (application['applicationType'] == 'CORPORATE') {
                    html += '<div class="nav-item-section">';
                    html += '<a id="corporateNav' + application['applicationId'] + '" class="tierOne" href="corporate-details?a=';
                    html += application['applicationId'];
                    html += '">';
                    html += application['serverName'];
                    html += '</a>';
                    html += '</div>';
                }
                $(navContainer).append(html);
            }
            showFloorplansDB(applications);
        });
        request.fail(function (jqXHR, textStatus) {
            if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                alert(jqXHR.responseJSON.message);
            } else {
                alert('An error occurred during your search. Please try again.');
            }
        });
    }
    $(searchInput).focus();
}

function clearFloorplanSearchDB(searchInput, clearButton, navContainer) {
    $(searchInput).val('');
    $(navContainer + ' .nav-item-section').each(function () {
        $(this).remove();
    });
    $(clearButton).hide();
    $(searchInput).focus();
    $('.tierTwoContent').empty();
    $('.tiewTwoContent').removeClass('floorplanListContent');
    $('.tierTwoContent').html('<h3>Too Many Properties</h3><p>Due to the large number of properties in your account, please search on the left for the property you would like to manage.</p><p>Or, you can <a href="?la=true">click here</a> to load all properties. This make take some extra time.</p>');
}

function showFloorplans(navContainer) {
    var applications = new Array();
    $(navContainer + ' > a').each(function () {
        if ($(this).hasClass('tierOne') && $(this).is(':visible')) {
            applications.push(this.id.substring(this.id.indexOf('Nav') + 3));
        }
    });
    $('.floorplan').hide();
    if (applications.length > 0) {
        $('.noMatch').hide();
        for (var i = 0; i < applications.length; i++) {
            $('#communitySection-' + applications[i]).show();
        }
    } else {
        $('.noMatch').show();
    }
}

function showFloorplansDB(applications) {
    $('.tierTwoContent').empty();
    if (applications.length > 0) {
        var applicationList = '';
        for (var i = 0; i < applications.length; i++) {
            applicationList += applications[i]['applicationId'];
            if (i < applications.length - 1) {
                applicationList += ',';
            }
        }
        $('.tierTwoContent').html('<img class="loading-gif" src="/assets/images/user/rvp/RentVisionLoading.gif" alt="Loading..."/>');
        var request = $.ajax({
            url: '/rapi/rvp/dashboard/get-dashboard-application-info?ail=' + applicationList,
            type: 'GET',
            dataType: 'html'
        });
        request.done(function (msg) {
            $('.tierTwoContent').html(msg);
            initSelect2();
            setupAvailabilityQuestions();
            $('.tierTwoContent').addClass('floorplanListContent');
        });
        request.fail(function (jqXHR, textStatus) {
            $('.tierTwoContent').html('<h3>Error</h3><p>An error occurred when searching for this property. Please try again.</p>');
        });
    } else {
        $('.tierTwoContent').html('<h3>No Matches Found</h3><p>We were unable to find any property matches for your search. Please try again.</p>');
    }
}

function toggleNav(selector, imagePrefix, identifier, holderPrefix) {
    var image = $(imagePrefix + identifier);
    if (image.attr('alt') == 'Expand') {
        image.attr('src', image.attr('src').replace('side', 'down'));
        image.attr('alt', 'Collapse');
        $(holderPrefix + identifier).show();
        $(holderPrefix + identifier + ' > a').show();
    } else {
        image.attr('src', image.attr('src').replace('down', 'side'));
        image.attr('alt', 'Expand');
        $(holderPrefix + identifier).hide();
    }
    $(selector).blur();
}

function updateAvailability(select, light) {
    document.getElementById(light).className = 'availabilityLight ' + $(select).find('option:selected').data('availability-name');
}

function enable(buttonId) {
    $(buttonId).prop('disabled', false);
    $(buttonId).show();
}

function disable(buttonId) {
    $(buttonId).prop('disabled', true);
}

function fillSlug(title, slug) {
    if (slug.value == '') {
        slug.value = title.value.split(' ').join('-').replace(/[^a-zA-Z0-9-_]/g, '').toLowerCase();
    }
}

function saveFormWithCheck(form, input, saved, api, additionalCheckFormFunction, afterSaveFunction) {
    if (checkForm(form, input, additionalCheckFormFunction)) {
        var request = $.ajax({
            url: '/rapi/rvp' + api,
            type: 'POST',
            data: $(form).serialize()
        });
        request.done(function (msg) {
            disable(input);
            $(saved).show().delay(2000).fadeOut();
            if (!!afterSaveFunction) {
                afterSaveFunction();
            }
        });
        request.fail(function (jqXHR, textStatus) {
            if (jqXHR.responseJSON && jqXHR.responseJSON.message) { // make sure there is a response json and that it has a message
                alert(jqXHR.responseJSON.message);
            } else {
                alert('We were unable to save your updates, please try again.');
            }
            enable(input);
        });
    }
    return false;
}

function saveForm(form, input, saved, api) {
    disable(input);
    var request = $.ajax({
        url: '/rapi/rvp' + api,
        type: 'POST',
        data: $(form).serialize()
    });
    request.done(function (msg) {
        $(saved).show().delay(2000).fadeOut();
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) { // make sure there is a response json and that it has a message
            alert(jqXHR.responseJSON.message);
        } else {
            alert('We were unable to save your updates, please try again.');
        }
        enable(input);
    });
    return false;
}

function checkUtilitiesForm(form) {
    var selectboxes = form.getElementsByTagName('select');
    for (var i = 0; i < selectboxes.length; i++) {
        var utilityId = selectboxes[i].id.substring('utilityPayer'.length);
        var checkbox = $('#utility' + utilityId);
        if (checkbox.is(':checked') && selectboxes[i].selectedIndex == 0) {
            alert('Please select a payer for all selected utilities.');
            selectboxes[i].focus();
            return false;
        }
    }
    return true;
}

function reorderPhotos(item, droppable) {
    var toMove = item.draggable.clone();
    item.draggable.remove();
    toMove.removeClass('ui-draggable-dragging');
    toMove.draggable({revert: 'invalid', stack: '.photos', scroll: true});
    toMove.droppable({
        hoverClass: 'highlightDroppable',
        drop: function (event, ui) {
            reorderPhotos(ui, $(this));
        }
    });
    toMove.css({left: '0', top: '0'});
    toMove.insertBefore(droppable);
    var allChildren = $('.photos');
    for (var i = 0; i < allChildren.length; i++) {
        var child = allChildren[i];
        var photoID = child.id.split('_')[1];
        $('#photoOrder' + photoID).val(i + 1);
    }
}

function loadFeaturedItems(allSelectBox, selectedSelectBox, featuredList, featuredId) {
    if (featuredList != null && featuredList.length > 0) {
        var featuredArray = featuredList.split(',');
        for (var i = 0; i < featuredArray.length; i++) {
            var option = $(featuredId + featuredArray[i]);
            $(selectedSelectBox).append(option);
        }
    }
}

function addToCustomItemsList(allSelectBox, selectedSelectBox) {
    var optionList = $(allSelectBox + ' option:selected');
    for (var i = 0; i < optionList.length; i++) {
        var option = optionList[i];
        option.selected = false;
        $(selectedSelectBox).append(option);
    }
}

function removeFromCustomItemsList(allSelectBox, selectedSelectBox) {
    var optionList = $(selectedSelectBox + ' option:selected');
    for (var i = 0; i < optionList.length; i++) {
        var option = optionList[i];
        option.selected = false;
        $(allSelectBox).append(option);
    }
}

function moveUpCustomItemsList(selectedSelectBox) {
    var lastElement;
    $(selectedSelectBox + ' option').each(function () {
        if (lastElement != null) {
            if (this.selected && !lastElement.selected) {
                $(this).insertBefore($(lastElement));
            } else {
                lastElement = this;
            }
        } else {
            lastElement = this;
        }
    });
}

function moveDownCustomItemsList(selectedSelectBox) {
    var lastElement;
    var reversed = new Array();
    $(selectedSelectBox + ' option').each(function () {
        reversed.push(this);
    });
    for (var i = reversed.length - 1; i >= 0; i--) {
        var element = reversed[i];
        if (lastElement != null) {
            if (element.selected && !lastElement.selected) {
                $(element).insertAfter($(lastElement));
            } else {
                lastElement = element;
            }
        } else {
            lastElement = element;
        }
    }
}

function loadEmail(emailTrackingId) {
    $('.intro').removeClass('selected');
    $('#emailIntro' + emailTrackingId).addClass('selected');
    $('.emailFullContent').hide();
    $('#email' + emailTrackingId).show();
    if ($('#coleasors' + emailTrackingId).hasClass('loading')) {
        loadColeasors(emailTrackingId);
    } else if ($('#previousMessages' + emailTrackingId).hasClass('loading')) {
        loadPreviousSMS(emailTrackingId);
    }
    $('#email' + emailTrackingId + ' select').each(function () {
        if (!$(this).hasClass('no-select2')) {
            $(this).select2({dropdownAutoWidth: true, width: 'auto'});
        }
    });
}

var lastInterval;
var lastProspectTimestamp;
var lastSearchInterval;
var lastSearchProspectTimestamp;
var possibleNames;
var possiblePhones;
var leasors = new Object();

function loadEmails(interval, type, isReset) {
    if ($('#moreProspects').is(':visible') && !$('#moreProspects').hasClass('loading')) {
        $('#moreProspects').addClass('loading');
        var leadType = $('#filterLeadType').val();
        if (!leadType) {
            leadType = '';
        }
        var request = $.ajax({
            url: '/rapi/rvp/contact/get-user-prospects?lpt=' + lastProspectTimestamp + '&i=' + interval + '&t=' + type + '&lt=' + leadType,
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            parseEmails(msg, type);
            if (msg.length > 0) {
                lastProspectTimestamp = msg[msg.length - 1]['createdOnMillis'];
                $('#moreProspects').removeClass('loading');
                if (msg.length < 20) {
                    $('#moreProspects').hide();
                    $('#noMoreProspects').show();
                }
            } else {
                $('#moreProspects').hide();
                $('#noMoreProspects').show();
                $('#noMoreProspects').addClass('loaded');
            }
            if (isReset) {
                postClearEmailSearch();
            }
        });
        request.fail(function (jqXHR, textStatus) {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        });
    }
}

var callClassifications;
var callStatuses;
var hasLeaseDelete;
var hasLeaseAdd;

function parseEmails(msg, type) {
    var currentYear = new Date().getFullYear();
    for (var i = 0; i < msg.length; i++) {
        if (type == 'LEAD') {
            var prospect = msg[i];
            if (prospect['emailTrackingId'] != null) {
                var emailContent = prospect['content'];
                var emailDate = new Date(prospect['createdOnMillis']);
                var nameSubstringIndex = emailContent.indexOf('<b>Name:</b>');
                var emailName = prospect['fromEmail'];
                if (nameSubstringIndex > 0) {
                    var nameFirstPart = emailContent.substring(nameSubstringIndex + 12);
                    if (nameFirstPart.indexOf('<') > 0) {
                        emailName = nameFirstPart.substring(0, nameFirstPart.indexOf('<'));
                    }
                }
                var phoneSubstringIndex = emailContent.indexOf('<b>Phone Number:</b>');
                var phone = '';
                if (phoneSubstringIndex > 0) {
                    var phoneFirstPart = emailContent.substring(phoneSubstringIndex + 20);
                    phone = phoneFirstPart.substring(0, phoneFirstPart.indexOf('<'));
                }
                var subject = 'Contact Request';
                if (prospect['communityName'] != null && prospect['communityName'] != 'Missing') {
                    subject = prospect['communityName'];
                } else if (prospect['corporateName'] != null && prospect['corporateName'] != 'Missing') {
                    subject = prospect['corporateName'];
                }
                var emailHtml = '<div id="emailIntroEMAIL' + prospect['emailTrackingId'] + '" class="intro" onclick="loadEmail(\'EMAIL' + prospect['emailTrackingId'] + '\');">';
                emailHtml += '<span class="date">' + getMonth(emailDate.getMonth()) + ' ' + emailDate.getDate() + (currentYear != emailDate.getFullYear() ? (', ' + emailDate.getFullYear()) : '') + '</span>';
                emailHtml += '<h4 class="from">' + $.trim(emailName) + '</h4>';
                emailHtml += '<p class="message subject">' + subject + '</p>';
                if (prospect['floorplanTitle'] != null && prospect['floorplanTitle'] != 'Missing') {
                    emailHtml += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                }
                emailHtml += '<img src="/assets/images/user/rvp/Email.svg" alt=""/>';
                if ($.trim(phone).length > 0) {
                    emailHtml += '<p class="message">' + $.trim(phone) + '</p>';
                }
                if (prospect['sourceName'] != null) {
                    emailHtml += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                }
                emailHtml += '<p class="clearFix">&nbsp;</p>';
                emailHtml += '</div>';
                $('#moreProspects').before(emailHtml);
                $('.emailContent').append(getProspectEmailContent(prospect, emailContent));
            } else if (prospect['callTrackingId'] != null) {
                var callDate = new Date(prospect['createdOnMillis']);
                var callFrom = prospect['callFrom'] == null ? 'N/A' : '(' + prospect['callFrom'].substring(2, 5) + ') ' + prospect['callFrom'].substring(5, 8) + '-' + prospect['callFrom'].substring(8, 12);
                var subject = 'Phone Call';
                if (prospect['communityName'] != null) {
                    subject = prospect['communityName'];
                } else if (prospect['corporateName'] != null) {
                    subject = prospect['corporateName'];
                }
                var phoneHtml = '<div id="emailIntroCALL' + prospect['callTrackingId'] + '" class="intro" onclick="loadEmail(\'CALL' + prospect['callTrackingId'] + '\');loadCallAnalysis(' + prospect['callTrackingId'] + ', ' + prospect['applicationId'] + ');">';
                phoneHtml += '<span class="date">' + getMonth(callDate.getMonth()) + ' ' + callDate.getDate() + (currentYear != callDate.getFullYear() ? (', ' + callDate.getFullYear()) : '') + '</span>';
                phoneHtml += '<h4 class="from">' + (prospect['fromName'] != null ? prospect['fromName'].toLowerCase() : callFrom) + '</h4>';
                phoneHtml += '<p class="message subject">' + subject + '</p>';
                if (prospect['floorplanTitle'] != null) {
                    phoneHtml += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                }
                phoneHtml += '<img src="/assets/images/user/rvp/Phone.svg" alt=""/>';
                phoneHtml += '<span class="callDuration">' + parseInt(prospect['callDurationInSeconds'] / 60) + ':' + (prospect['callDurationInSeconds'] % 60 < 10 ? '0' : '') + prospect['callDurationInSeconds'] % 60 + '</span>';
                if (prospect['fromName'] != null) {
                    phoneHtml += '<p class="message">' + callFrom + '</p>';
                }
                if (prospect['sourceName'] != null) {
                    phoneHtml += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                }
                phoneHtml += '<p class="clearFix">&nbsp;</p>';
                phoneHtml += '</div>';
                $('#moreProspects').before(phoneHtml);
                $('.emailContent').append(getProspectCallContent(prospect));
            } else if (prospect['smsTrackingId'] != null) {
                var smsDate = new Date(prospect['createdOnMillis']);
                var smsFrom = '(' + prospect['smsFrom'].substring(2, 5) + ') ' + prospect['smsFrom'].substring(5, 8) + '-' + prospect['smsFrom'].substring(8, 12);
                var subject = 'Text Message';
                if (prospect['communityName'] != null) {
                    subject = prospect['communityName'];
                } else if (prospect['corporateName'] != null) {
                    subject = prospect['corporateName'];
                }
                var smsHtml = '<div id="emailIntroSMS' + prospect['smsTrackingId'] + '" class="intro" onclick="loadEmail(\'SMS' + prospect['smsTrackingId'] + '\');">';
                smsHtml += '<span class="date">' + getMonth(smsDate.getMonth()) + ' ' + smsDate.getDate() + (currentYear != smsDate.getFullYear() ? (', ' + smsDate.getFullYear()) : '') + '</span>';
                smsHtml += '<h4 class="from">' + smsFrom + '</h4>';
                smsHtml += '<p class="message subject">' + subject + '</p>';
                if (prospect['floorplanTitle'] != null) {
                    smsHtml += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                }
                smsHtml += '<img src="/assets/images/user/rvp/Text.svg" alt=""/>';
                if (prospect['sourceName'] != null) {
                    smsHtml += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                }
                smsHtml += '<p class="clearFix">&nbsp;</p>';
                smsHtml += '</div>';
                $('#moreProspects').before(smsHtml);
                $('.emailContent').append(getProspectSmsContent(prospect));
            }
        } else if (type == 'MAINTENANCE' || type == 'OTHER') {
            var email = msg[i];
            var emailContent = email['content'];
            var emailDate = new Date(email['createdOnMillis']);
            var name = null;
            for (var j = 0; j < possibleNames.length; j++) {
                var possibleName = possibleNames[j];
                var substringIndex = emailContent.indexOf(possibleName);
                if (substringIndex > 0) {
                    var nameFirstPart = emailContent.substring(substringIndex + possibleName.length);
                    if (nameFirstPart.indexOf('<') > 0) {
                        name = nameFirstPart.substring(0, nameFirstPart.indexOf('<'));
                    }
                    break;
                }
            }
            var phone = null;
            for (var j = 0; j < possiblePhones.length; j++) {
                var possiblePhone = possiblePhones[j];
                var substringIndex = emailContent.indexOf(possiblePhone);
                if (substringIndex > 0) {
                    var phoneFirstPart = emailContent.substring(substringIndex + possiblePhone.length);
                    if (phoneFirstPart.indexOf('<') > 0) {
                        phone = phoneFirstPart.substring(0, phoneFirstPart.indexOf('<'));
                    }
                    break;
                }
            }
            var subject = 'Maintenance Request';
            if (email['communityName'] != null && email['communityName'] != 'Missing') {
                subject = email['communityName'];
            } else if (email['corporateName'] != null && email['corporateName'] != 'Missing') {
                subject = email['corporateName'];
            }
            var emailHtml = '<div id="emailIntro' + email['emailTrackingId'] + '" class="intro" onclick="loadEmail(\'' + email['emailTrackingId'] + '\');">';
            emailHtml += '<span class="date">' + getMonth(emailDate.getMonth()) + ' ' + emailDate.getDate() + (currentYear != emailDate.getFullYear() ? (', ' + emailDate.getFullYear()) : '') + '</span>';
            emailHtml += '<h4 class="from">' + (name != null ? $.trim(name) : email['fromEmail']) + '</h4>';
            emailHtml += '<p class="message subject">' + subject + '</p>';
            if (phone != null) {
                emailHtml += '<p class="message">' + $.trim(phone) + '</p>';
            } else if (type == 'OTHER') {
                emailHtml += '<p class="message">' + email['subject'] + '</p>';
            }
            emailHtml += '</div>';
            $('#moreProspects').before(emailHtml);
            var emailBody = '<div class="emailFullContent" id="email' + email['emailTrackingId'] + '" style="display:none;">';
            emailBody += '<p><strong>Received:</strong> ' + (email['createdOnString'] != null ? email['createdOnString'] : 'N/A') + '</p>';
            emailBody += '<b><label id="spamEmailToggleLabel' + email['emailTrackingId'] + '" for="spamEmailToggle' + email['emailTrackingId'] + '" class="spamToggleLabel">' + (email['spam'] == true ? 'Unmark' : 'Mark') + ' Email as Spam</label></b>';
            emailBody += '<div class="rvCheckBoxWrapper">';
            emailBody += '<input type="checkbox" value="true" class="rvCheckBoxInput" ' + (email['spam'] == true ? 'checked' : '') + ' name="spamEmailToggle' + email['emailTrackingId'] + '" id="spamEmailToggle' + email['emailTrackingId'] + '" onchange="toggleEmailIsSpam(\'' + email['emailTrackingId'] + '\')"/>';
            emailBody += '<span class="rvCheckBox"></span></div>';
            emailBody += '<p style="margin:20px 0;' + (email['spam'] == true ? '' : ' display:none;') + '" id="spamAlert' + email['emailTrackingId'] + '" class="spamAlert"><strong>Spam Alert!</strong> This email has been flagged due to content matching spam behavior. Please exercise caution in responding or clicking on links below.</p>';
            emailBody += emailContent.replace(/width="600"/g, 'width="100%"').replace(/width="580"/g, 'width="100%"');
            emailBody += '</div>';
            $('.emailContent').append(emailBody);
        } else if (type == 'LEASES') {
            var lease = msg[i];
            var leaseDate = new Date(lease['createdOn']);
            var moveInDate = new Date(lease['moveInDate']);
            var leaseHtml = '<div id="emailIntro' + lease['leaseId'] + '" class="intro" onclick="loadEmail(\'' + lease['leaseId'] + '\');">';
            leaseHtml += '<span class="date" id="leaseDate' + lease['leaseId'] + '">' + getMonth(leaseDate.getMonth()) + ' ' + leaseDate.getDate() + (currentYear != leaseDate.getFullYear() ? (', ' + leaseDate.getFullYear()) : '') + '</span>';
            leaseHtml += '<h4 class="from">' + lease['primaryCustomerName'] + '</h4>';
            leaseHtml += '<p class="message subject">' + lease['applicationDisplayName'] + '</p>';
            if (lease['floorplanTitle'] != null) {
                leaseHtml += '<p class="message" id="leaseFloorplanTitle' + lease['leaseId'] + '">' + lease['floorplanTitle'] + '</p>';
            }
            if (lease['firstContact'] != null) {
                leaseHtml += '<p class="message" id="leaseSource' + lease['leaseId'] + '">Source: <span' + (lease['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + lease['sourceName'] + '</span></p>';
            }
            leaseHtml += '</div>';
            $('#moreProspects').before(leaseHtml);
            var leaseBody = '<div class="emailFullContent leaseContent" id="email' + lease['leaseId'] + '" style="display:none;">';
            if (hasLeaseDelete) {
                leaseBody += '<form action="contact-leases" method="POST" onsubmit="return confirm(\'Are you sure you want to delete the lease for ' + lease['primaryCustomerName'] + '?\');">';
                leaseBody += '<input type="hidden" name="formType" value="LEASE_DELETE"/>';
                leaseBody += '<input type="hidden" name="leaseId" value="' + lease['leaseId'] + '"/>';
                leaseBody += '<input style="float:right;" class="inverted-accent-inline-btn" type="submit" value="Delete Lease"/>';
                leaseBody += '</form>';
            }
            leaseBody += '<h3>Lease for ' + lease['primaryCustomerName'] + '</h3>';
            leaseBody += '<div class="leaseDetails standard-form">';
            leaseBody += '<p><strong>' + lease['applicationDisplayName'] + '</strong></p>';
            if (hasLeaseAdd) {
                leaseBody += '<p class="editable"><strong>Floorplan:</strong> ';
                leaseBody += '<span id="floorplanLabelWrapper' + lease['leaseId'] + '"><a href="#" onclick="$(\'#floorplanLabelWrapper' + lease['leaseId'] + '\').hide();$(\'#floorplanInputWrapper' + lease['leaseId'] + '\').show();populateFloorplans(' + lease['applicationId'] + ', \'#floorplanInput' + lease['leaseId'] + '\', \'#floorplanInputWrapper' + lease['leaseId'] + '\', \'' + lease['floorplanTitle'] + '\');return false;"><span id="floorplanLabel' + lease['leaseId'] + '">' + lease['floorplanTitle'] + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></span>';
                leaseBody += '<span id="floorplanInputWrapper' + lease['leaseId'] + '" style="display:none;"><img class="loading-gif" src="/assets/images/user/rvp/RentVisionLoading.gif" alt="Loading..."/><select id="floorplanInput' + lease['leaseId'] + '"></select> <a href="#" onclick="saveLeaseInfo(\'floorplan\', \'' + lease['leaseId'] + '\', \'FP\');return false;">Save</a></span>';
                leaseBody += '</p>';
                leaseBody += '<p class="editable"><strong>Application Date:</strong> ';
                leaseBody += '<span id="applicationDateLabelWrapper' + lease['leaseId'] + '"><a href="#" onclick="$(\'#applicationDateLabelWrapper' + lease['leaseId'] + '\').hide();$(\'#applicationDateInputWrapper' + lease['leaseId'] + '\').show();return false;"><span id="applicationDateLabel' + lease['leaseId'] + '">' + lease['createdOnString'] + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></span>';
                leaseBody += '<span id="applicationDateInputWrapper' + lease['leaseId'] + '" style="display:none;"><input class="leaseApplicationDatepicker" id="applicationDateInput' + lease['leaseId'] + '" maxlength="100" value="' + (leaseDate.getMonth() + 1) + '/' + leaseDate.getDate() + '/' + leaseDate.getFullYear() + '"/> <a href="#" onclick="saveLeaseInfo(\'applicationDate\', \'' + lease['leaseId'] + '\', \'AD\');return false;">Save</a></span>';
                leaseBody += '</p>';
                leaseBody += '<p class="editable"><strong>Move In Date:</strong> ';
                leaseBody += '<span id="moveInDateLabelWrapper' + lease['leaseId'] + '"><a href="#" onclick="$(\'#moveInDateLabelWrapper' + lease['leaseId'] + '\').hide();$(\'#moveInDateInputWrapper' + lease['leaseId'] + '\').show();return false;"><span id="moveInDateLabel' + lease['leaseId'] + '">' + lease['moveInDateString'] + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></span>';
                leaseBody += '<span id="moveInDateInputWrapper' + lease['leaseId'] + '" style="display:none;"><input class="leaseMoveInDatepicker" id="moveInDateInput' + lease['leaseId'] + '" maxlength="100" value="' + (moveInDate.getMonth() + 1) + '/' + moveInDate.getDate() + '/' + moveInDate.getFullYear() + '"/> <a href="#" onclick="saveLeaseInfo(\'moveInDate\', \'' + lease['leaseId'] + '\', \'MD\');return false;">Save</a></span>';
                leaseBody += '</p>';
                leaseBody += '<p class="editable"><strong>Rent:</strong> ';
                leaseBody += '<span id="monthlyRentLabelWrapper' + lease['leaseId'] + '"><a href="#" onclick="$(\'#monthlyRentLabelWrapper' + lease['leaseId'] + '\').hide();$(\'#monthlyRentInputWrapper' + lease['leaseId'] + '\').show();return false;"><span id="monthlyRentLabel' + lease['leaseId'] + '">' + (lease['monthlyRent'] != null ? '$' + lease['monthlyRent'] : 'N/A') + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></span>';
                leaseBody += '<span id="monthlyRentInputWrapper' + lease['leaseId'] + '" style="display:none;">$<input class="number" id="monthlyRentInput' + lease['leaseId'] + '" maxlength="5" size="5" value="' + lease['monthlyRent'] + '"/> <a href="#" onclick="saveLeaseInfo(\'monthlyRent\', \'' + lease['leaseId'] + '\', \'MR\');return false;">Save</a></span>';
                leaseBody += '</p>';
            } else {
                leaseBody += '<p><strong>Floorplan:</strong> ';
                leaseBody += '<span id="floorplanLabelWrapperNonEdit' + lease['leaseId'] + '"><span id="floorplanLabel' + lease['leaseId'] + '">' + lease['floorplanTitle'] + '</span></span>';
                leaseBody += '</p>';
                leaseBody += '<p><strong>Application Date:</strong> ';
                leaseBody += '<span id="applicationDateLabelWrapperNonEdit' + lease['leaseId'] + '"><span id="applicationDateLabel' + lease['leaseId'] + '">' + lease['createdOnString'] + '</span></span>';
                leaseBody += '</p>';
                leaseBody += '<p><strong>Move In Date:</strong> ';
                leaseBody += '<span id="moveInDateLabelWrapperNonEdit' + lease['leaseId'] + '"><span id="moveInDateLabel' + lease['leaseId'] + '">' + lease['moveInDateString'] + '</span></span>';
                leaseBody += '</p>';
                leaseBody += '<p><strong>Rent:</strong> ';
                leaseBody += '<span id="monthlyRentLabelWrapperNonEdit' + lease['leaseId'] + '"><span id="monthlyRentLabel' + lease['leaseId'] + '">' + (lease['monthlyRent'] != null ? '$' + lease['monthlyRent'] : 'N/A') + '</span></span>';
                leaseBody += '</p>';
            }


            leaseBody += '<p class="editable"><strong>Notes:</strong> ';
            leaseBody += '<span id="notesLabelWrapper' + lease['leaseId'] + '"><a href="#" onclick="$(\'#notesLabelWrapper' + lease['leaseId'] + '\').hide();$(\'#notesInputWrapper' + lease['leaseId'] + '\').show();return false;"><span id="notesLabel' + lease['leaseId'] + '">' + (lease['notes'] != null ? lease['notes'] : 'N/A') + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></span>';
            leaseBody += '<span id="notesInputWrapper' + lease['leaseId'] + '" style="display:none;"><textarea id="notesInput' + lease['leaseId'] + '" rows="2" cols="40" >' + lease['notes'] + '</textarea> <a href="#" onclick="saveLeaseInfo(\'notes\', \'' + lease['leaseId'] + '\', \'N\');return false;">Save</a></span>';
            leaseBody += '</p>';
            leaseBody += '</div>';
            leaseBody += '<h3>First Contact</h3>';
            if (lease['firstContact'] != null) {
                leaseBody += '<p id="firstContactSource' + lease['leaseId'] + '"><strong>Source:</strong> <span' + (lease['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + lease['sourceName'] + '</span></p>';
                leaseBody += '<p id="firstContactDate' + lease['leaseId'] + '"><strong>Date:</strong> ' + lease['firstContactString'] + '</p>';
            } else {
                leaseBody += '<p id="firstContactSource' + lease['leaseId'] + '"><strong>Source:</strong> Unknown</p>';
                leaseBody += '<p id="firstContactDate' + lease['leaseId'] + '"><strong>Date:</strong> Unknown</p>';
            }
            leaseBody += '<div class="leaseDetails leaseResidents">';
            leaseBody += '<h3>Residents</h3>';
            leaseBody += '<h4 class="editable"><a href="#" onclick="loadCustomer(\'' + lease['applicationId'] + '\', \'' + lease['leaseId'] + '\', \'' + lease['primaryCustomerId'] + '\');return false;"><span>' + lease['primaryCustomerName'] + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></h4>';
            var contactInfo = lease['primaryCustomerContactInfo'];
            if (contactInfo['EMAIL'] != null) {
                leaseBody += '<p><strong>Email:</strong>';
                for (var j = 0; j < contactInfo["EMAIL"].length; j++) {
                    leaseBody += ' ' + contactInfo['EMAIL'][j]['label'] + ': ' + contactInfo['EMAIL'][j]['value'];
                    if (j < contactInfo['EMAIL'].length - 1) {
                        leaseBody += ',';
                    }
                }
                leaseBody += '</p>';
            }
            if (contactInfo['PHONE'] != null) {
                leaseBody += '<p><strong>Phone:</strong>';
                for (var j = 0; j < contactInfo["PHONE"].length; j++) {
                    leaseBody += ' ' + contactInfo['PHONE'][j]['label'] + ': ' + contactInfo['PHONE'][j]['value'];
                    if (j < contactInfo['PHONE'].length - 1) {
                        leaseBody += ',';
                    }
                }
                leaseBody += '</p>';
            }
            leaseBody += '<input type="hidden" id="application' + lease['leaseId'] + '" value="' + lease['applicationId'] + '"/>';
            leaseBody += '<div id="coleasors' + lease['leaseId'] + '" class="loading" style="display:none;"></div>';
            leaseBody += '<p class="addResident"><a href="#" onclick="loadCustomer(\'' + lease['applicationId'] + '\', \'' + lease['leaseId'] + '\');return false;"><img src="/assets/images/user/rvp/PlusJade.svg" alt="Add"/> Add Resident</a></p>';
            leaseBody += '</div>';
            leaseBody += '<div id="customerContact' + lease['leaseId'] + '" style="display:none;">';
            leaseBody += '<h3>Communication</h3>';
            leaseBody += '</div>';
            leaseBody += '<script type="text/javascript">';
            leaseBody += 'var tmpArray = new Array();';
            leaseBody += 'tmpArray.push(' + lease['primaryCustomerId'] + ');';
            leaseBody += 'leasors["' + lease['leaseId'] + '"] = tmpArray;';
            leaseBody += '$("#applicationDateInput' + lease['leaseId'] + '").datepicker({ maxDate: "0D" });';
            leaseBody += '$("#moveInDateInput' + lease['leaseId'] + '").datepicker();';
            leaseBody += '</script>';
            leaseBody += '</div>';
            $('.emailContent').append(leaseBody);
        }
    }
}

function getProspectEmailContent(prospect, emailContent) {
    var emailBody = '<div class="emailFullContent" id="emailEMAIL' + prospect['emailTrackingId'] + '" style="display:none;">';
    emailBody += '<img class="emailType" src="/assets/images/user/rvp/Email.svg" alt=""/>';
    emailBody += '<p><strong>Received:</strong> ' + (prospect['createdOnString'] != null ? prospect['createdOnString'] : 'N/A') + '</p>';
    emailBody += '<b><label id="spamEmailToggleLabel' + prospect['emailTrackingId'] + '" for="spamEmailToggle' + prospect['emailTrackingId'] + '" class="spamToggleLabel">' + (prospect['spam'] == true ? 'Unmark' : 'Mark') + ' Email as Spam</label></b>';
    emailBody += '<div class="rvCheckBoxWrapper">';
    emailBody += '<input type="checkbox" value="true" class="rvCheckBoxInput" ' + (prospect['spam'] == true ? 'checked' : '') + ' name="spamEmailToggle' + prospect['emailTrackingId'] + '" id="spamEmailToggle' + prospect['emailTrackingId'] + '" onchange="toggleEmailIsSpam(\'' + prospect['emailTrackingId'] + '\')"/>';
    emailBody += '<span class="rvCheckBox"></span></div>';
    emailBody += '<p style="margin:20px 0;' + (prospect['spam'] == true ? '' : ' display:none;') + '" id="spamAlert' + prospect['emailTrackingId'] + '" class="spamAlert"><strong>Spam Alert!</strong> This email has been flagged due to content matching spam behavior. Please exercise caution in responding or clicking on links below.</p>';
    if (prospect['sourceId'] == '1') {
        emailBody += emailContent.replace(/width="600"/g, 'width="100%"');
    } else {
        emailBody += '<div class="vendorEmailWrapper">' + emailContent + '</div>';
    }
    emailBody += '<p style="margin-top:40px;"><strong>Classification:</strong> ' + (prospect['classification'] != null ? prospect['classification'] : 'None') + '</p>';
    emailBody += '<p><strong>Classified By:</strong> ' + (prospect['classifiedBy'] != null ? prospect['classifiedBy'] : 'N/A') + '</p>';
    emailBody += '<p><strong>Classified On:</strong> ' + (prospect['classifiedOnString'] != null ? prospect['classifiedOnString'] : 'N/A') + '</p>';
    emailBody += '<p><strong>Notes:</strong> ' + (prospect['notes'] != null ? prospect['notes'] : 'N/A') + '</p>';
    emailBody += '<form class="updateCall" id="emailDetailsForm' + prospect['emailTrackingId'] + '" action="#" method="POST">';
    emailBody += '<h4>Update Email Information</h4>';
    emailBody += '<ul>';
    emailBody += '<li class=\'inline-form-input\'>';
    emailBody += '<label for="emailClassificationValue' + prospect['emailTrackingId'] + '">Classification:</label>';
    emailBody += '<select id="emailClassificationValue' + prospect['emailTrackingId'] + '" onchange="$(\'#emailDetails' + prospect['emailTrackingId'] + '\').prop(\'disabled\',false);">';
    emailBody += '<option value="">Choose Classification</option>';
    for (var cc = 0; cc < callClassifications.length; cc++) {
        var classification = callClassifications[cc];
        emailBody += '<option value="' + classification['classificationId'] + '" ' + (prospect['classificationId'] != null && prospect['classificationId'] == classification['classificationId'] ? 'selected="selected"' : '') + '>' + classification['name'] + '</option>';
    }
    emailBody += '</select>';
    emailBody += '</li>';
    emailBody += '<li>';
    emailBody += '<label for="emailNotesValue' + prospect['emailTrackingId'] + '">Notes:</label>';
    emailBody += '<textarea id="emailNotesValue' + prospect['emailTrackingId'] + '" onkeyup="$(\'#emailDetails' + prospect['emailTrackingId'] + '\').prop(\'disabled\',false);" rows="5" cols="50">' + (prospect['notes'] ? prospect['notes'] : '') + '</textarea>';
    emailBody += '</li>';
    emailBody += '</ul>';
    emailBody += '<input id="emailDetails' + prospect['emailTrackingId'] + '" class="accent-btn" type="submit" value="Update" disabled="disabled"/>';
    emailBody += '<span id="emailDetailsSuccess' + prospect['emailTrackingId'] + '" class="AVAILABLE" style="margin-left:.5em;display:none;">Updated!</span>';
    emailBody += '</form>';
    emailBody += '<script type="text/javascript">';
    emailBody += '$("#emailDetailsForm' + prospect['emailTrackingId'] + '").submit(function() {';
    emailBody += '$("#emailDetails' + prospect['emailTrackingId'] + '").prop(\'disabled\',true);';
    emailBody += 'var request = $.ajax({';
    emailBody += 'url: "/rapi/rvp/email/update-email-details?eti=' + prospect['emailTrackingId'] + '&cci="+$("#emailClassificationValue' + prospect['emailTrackingId'] + '").val()+"&en="+encodeURIComponent($("#emailNotesValue' + prospect['emailTrackingId'] + '").val()),';
    emailBody += 'type: "PUT",';
    emailBody += 'dataType: "text"';
    emailBody += '});';
    emailBody += 'request.done(function(msg) {';
    emailBody += '$("#emailDetailsSuccess' + prospect['emailTrackingId'] + '").show().delay(2000).fadeOut();';
    emailBody += '});';
    emailBody += 'request.fail(function(jqXHR, textStatus) {';
    emailBody += 'if (jqXHR.responseJson && jqXHR.responseJson.message) {';
    emailBody += 'alert(jqXHR.responseJson.message);';
    emailBody += '} else {';
    emailBody += 'alert("An error occurred during notes update. Please try again.");';
    emailBody += '}';
    emailBody += '});';
    emailBody += 'return false;';
    emailBody += '});';
    emailBody += '</script>';
    emailBody += '</div>';
    return emailBody;
}

function getProspectCallContent(prospect) {
    var callFrom = prospect['callFrom'] == null ? 'N/A' : '(' + prospect['callFrom'].substring(2, 5) + ') ' + prospect['callFrom'].substring(5, 8) + '-' + prospect['callFrom'].substring(8, 12);
    var callTo = prospect['callTo'] == null ? 'N/A' : '(' + prospect['callTo'].substring(2, 5) + ') ' + prospect['callTo'].substring(5, 8) + '-' + prospect['callTo'].substring(8, 12);
    var callBody = '<div class="emailFullContent CALL" id="emailCALL' + prospect['callTrackingId'] + '" style="display:none;">';
    callBody += '<div class="phoneCall">';
    callBody += '<div class="toFrom">';
    callBody += '<p><strong>From:</strong> ' + callFrom + '</p>';
    callBody += '<p><strong>To:</strong> ' + callTo + '</p>';
    if (prospect['recordingUrl'] != null) {
        callBody += '<a class="download tooltip" title="Download Recording" onclick="downloadFromExternalURL(\'' + prospect['recordingUrl'] + '.mp3\', \'call-' + prospect['createdOnMillis'] + '.mp3\')"><img src="/assets/images/user/rvp/Download.svg" alt="Click to download MP3."/></a>';
        callBody += '<a class="recording" href="' + prospect['recordingUrl'] + '" target="_blank">Click to listen <img src="/assets/images/user/rvp/Listen.svg" alt=""/></a>';
    }
    callBody += '</div>';
    callBody += '<div class="callDetails">';
    if (prospect['sourceName'] != null && prospect['sourceName'].indexOf('RentVision') >= 0) {
        callBody += '<p class="source">Source: <span style="color:#1e988a;">' + prospect['sourceName'] + '</span></p>';
    } else {
        callBody += '<p class="source">Source: ' + (prospect['sourceName'] != null ? prospect['sourceName'] : 'N/A') + '</p>';
    }
    callBody += (prospect['corporateName'] != null ? ('<p class=\'color-primary\'><strong>' + prospect['corporateName'] + '</strong></p>') : '');
    callBody += (prospect['communityName'] != null ? ('<p class=\'color-primary\'><strong>' + prospect['communityName'] + '</strong></p>') : '');
    callBody += (prospect['floorplanTitle'] != null ? ('<p class=\'color-primary\'>' + prospect['floorplanTitle'] + '</p>') : '');
    callBody += '<p class="status">';
    if (prospect['callClassification'] != null) {
        callBody += '<span class=' + prospect['callStatus'] + '>' + (prospect['callStatusString'] != null ? prospect['callStatusString'] : 'N/A') + '</span> - ';
    }
    callBody += (prospect['createdOnString'] != null ? prospect['createdOnString'] : 'N/A') + ' - ' + parseInt(prospect['callDurationInSeconds'] / 60) + ' min ' + prospect['callDurationInSeconds'] % 60 + ' sec</p>';
    callBody += '<div class="caller">';
    callBody += '<p><strong>Caller Info:</strong></p>';
    callBody += '<p>' + (prospect['fromName'] != null ? prospect['fromName'].toLowerCase() : 'N/A') + '</p>';
    callBody += '<p>' + (prospect['fromCity'] != null ? prospect['fromCity'].toLowerCase() : 'N/A') + ', ' + (prospect['fromState'] != null ? prospect['fromState'] : 'N/A') + ' ' + (prospect['fromZip'] != null ? prospect['fromZip'] : 'N/A') + '</p>';
    callBody += '<p>' + (prospect['fromCountry'] != null ? prospect['fromCountry'] : 'N/A') + '</p>';
    callBody += '</div>';
    callBody += '<p><strong>Classification:</strong> ' + (prospect['classification'] != null ? prospect['classification'] : 'None') + '</p>';
    callBody += '<p><strong>Classified By:</strong> ' + (prospect['classifiedBy'] != null ? prospect['classifiedBy'] : 'N/A') + '</p>';
    callBody += '<p><strong>Classified On:</strong> ' + (prospect['classifiedOnString'] != null ? prospect['classifiedOnString'] : 'N/A') + '</p>';
    callBody += '<p><strong>Notes:</strong> ' + (prospect['notes'] != null ? prospect['notes'] : 'N/A') + '</p>';
    callBody += '</div>';
    callBody += '<form class="updateCall" id="callDetailsForm' + prospect['callTrackingId'] + '" action="#" method="POST">';
    callBody += '<h4>Update Call Information</h4>';
    callBody += '<ul>';
    callBody += '<li class=\'inline-form-input\'>';
    callBody += '<label for="classificationValue' + prospect['callTrackingId'] + '">Classification:</label>';
    callBody += '<select id="classificationValue' + prospect['callTrackingId'] + '" onchange="$(\'#callDetails' + prospect['callTrackingId'] + '\').prop(\'disabled\',false);">';
    callBody += '<option value="">Choose Classification</option>';
    for (var cc = 0; cc < callClassifications.length; cc++) {
        var classification = callClassifications[cc];
        callBody += '<option value="' + classification['classificationId'] + '" ' + (prospect['classificationId'] != null && prospect['classificationId'] == classification['classificationId'] ? 'selected="selected"' : '') + '>' + classification['name'] + '</option>';
    }
    callBody += '</select>';
    callBody += '</li>';
    callBody += '<li class=\'inline-form-input\'>';
    callBody += '<label for="statusValue' + prospect['callTrackingId'] + '">Status:</label>';
    callBody += '<select id="statusValue' + prospect['callTrackingId'] + '" onchange="$(\'#callDetails' + prospect['callTrackingId'] + '\').prop(\'disabled\',false);">';
    for (var cs = 0; cs < callStatuses.length; cs++) {
        var status = callStatuses[cs];
        callBody += '<option value="' + status['codename'] + '" ' + (prospect['callStatus'] != null && prospect['callStatus'] == status['codename'] ? 'selected="selected"' : '') + '>' + status['label'] + '</option>';
    }
    callBody += '</select>';
    callBody += '</li>';
    callBody += '<li>';
    callBody += '<label for="notesValue' + prospect['callTrackingId'] + '">Notes:</label>';
    callBody += '<textarea id="notesValue' + prospect['callTrackingId'] + '" onkeyup="$(\'#callDetails' + prospect['callTrackingId'] + '\').prop(\'disabled\',false);" rows="5" cols="50">' + (prospect['notes'] ? prospect['notes'] : '') + '</textarea>';
    callBody += '</li>';
    callBody += '</ul>';
    callBody += '<input id="callDetails' + prospect['callTrackingId'] + '" class="accent-btn" type="submit" value="Update" disabled="disabled"/>';
    callBody += '<span id="callDetailsSuccess' + prospect['callTrackingId'] + '" class="AVAILABLE" style="margin-left:.5em;display:none;">Updated!</span>';
    callBody += '</form>';
    callBody += '<script type="text/javascript">';
    callBody += '$("#callDetailsForm' + prospect['callTrackingId'] + '").submit(function() {';
    callBody += '$("#callDetails' + prospect['callTrackingId'] + '").prop(\'disabled\',true);';
    callBody += 'var request = $.ajax({';
    callBody += 'url: "/rapi/rvp/call-tracking/update-call-details?cti=' + prospect['callTrackingId'] + '&cci="+$("#classificationValue' + prospect['callTrackingId'] + '").val()+"&cs="+$("#statusValue' + prospect['callTrackingId'] + '").val()+"&cn="+encodeURIComponent($("#notesValue' + prospect['callTrackingId'] + '").val()),';
    callBody += 'type: "PUT",';
    callBody += 'dataType: "text"';
    callBody += '});';
    callBody += 'request.done(function(msg) {';
    callBody += '$("#callDetailsSuccess' + prospect['callTrackingId'] + '").show().delay(2000).fadeOut();';
    callBody += '});';
    callBody += 'request.fail(function(jqXHR, textStatus) {';
    callBody += 'if (jqXHR.responseJson && jqXHR.responseJson.message) {';
    callBody += 'alert(jqXHR.responseJson.message);';
    callBody += '} else {';
    callBody += 'alert("An error occurred during classification update. Please try again.");';
    callBody += '}';
    callBody += '});';
    callBody += 'return false;';
    callBody += '});';
    callBody += '</script>';
    callBody += '</div>';
    callBody += '</div>';
    return callBody;
}

function loadCallAnalysis(callTrackingId, applicationId) {
    if (document.getElementById(`call-analysis${callTrackingId}`) === null) {
        const request = $.ajax({
            url: `/rapi/rvp/call-tracking/get-call-analysis?cti=${callTrackingId}&a=${applicationId}`,
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            if (msg != null && !$.isEmptyObject(msg)) {
                let analysisWrapper = `<div class="call-analysis" id="call-analysis${callTrackingId}"><h4>Call Analysis<span class="icon-text"><img src="/assets/images/user/rvp/AiIcon.svg" class="ai-icon"/>Powered by AI</span></h4>`;
                const transcription = msg.TRANSCRIPTION, summary = msg.CALL_SUMMARY;
                analysisWrapper += `<p><strong>Call Summary:</strong> ${summary}</p>`;
                if (transcription != null) {
                    if (transcription.length > 450) {
                        analysisWrapper += `<p class="call-transcription"><strong>Call Transcription:</strong> ${transcription.substring(0, 400)}<span id="transcript${callTrackingId}" style="display: none;">${transcription.substring(401)}</span>`;
                        analysisWrapper += `<a href="#" onclick="$(\'#transcript${callTrackingId}\').show();$(this).hide();return false;">Show More</a></p>`;
                    } else {
                        analysisWrapper += `<p><strong>Call Transcription:</strong> ${transcription}</p>`;
                    }
                }
                analysisWrapper += '</div>';
                $(`#emailCALL${callTrackingId} .callDetails`).after(analysisWrapper);
            } else {
                $(`#emailCALL${callTrackingId} .callDetails`).after(`<span id="call-analysis${callTrackingId}">&nbsp;</span>`);
            }
        });
    }
}

// Adapted from the first part of this stack overflow answer: https://stackoverflow.com/a/9834261
function downloadFromExternalURL(fileURL, filename) {
    const xhr = new XMLHttpRequest();
    xhr.responseType = 'blob';
    xhr.onload = function () {
        if (xhr.status === 200) {
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(xhr.response);
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            a.remove();
        } else {
            window.alert('There was an error downloading the file.');
        }
    };
    xhr.open('GET', fileURL);
    xhr.send();
}

var hasSMSReplyAccess = false;

function getProspectSmsContent(prospect) {
    var smsFrom = prospect['smsFrom'] == null ? 'N/A' : '(' + prospect['smsFrom'].substring(2, 5) + ') ' + prospect['smsFrom'].substring(5, 8) + '-' + prospect['smsFrom'].substring(8, 12);
    var smsTo = prospect['smsTo'] == null ? 'N/A' : '(' + prospect['smsTo'].substring(2, 5) + ') ' + prospect['smsTo'].substring(5, 8) + '-' + prospect['smsTo'].substring(8, 12);
    var smsBody = '<div class="emailFullContent CALL" id="emailSMS' + prospect['smsTrackingId'] + '" style="display:none;">';
    smsBody += '<div class="phoneCall">';
    smsBody += '<div class="toFrom">';
    smsBody += '<p><strong>From:</strong> ' + smsFrom + '</p>';
    smsBody += '<p><strong>To:</strong> ' + smsTo + '</p>';
    smsBody += '<p><strong>Messager Info:</strong> ';
    smsBody += '<span class=\'capitalize\'>' + (prospect['fromCity'] != null ? prospect['fromCity'].toLowerCase() : 'N/A') + '</span>, ' + (prospect['fromState'] != null ? prospect['fromState'] : 'N/A') + ' ' + (prospect['fromZip'] != null ? prospect['fromZip'] : 'N/A') + ', ' + (prospect['fromCountry'] != null ? prospect['fromCountry'] : 'N/A') + '</p>';
    smsBody += '</div>';
    smsBody += '<div class="callDetails">';
    if (prospect['sourceName'] != null && prospect['sourceName'].indexOf('RentVision') >= 0) {
        smsBody += '<p class="source">Source: <span style="color:#1e988a;">' + prospect['sourceName'] + '</span></p>';
    } else {
        smsBody += '<p class="source">Source: ' + (prospect['sourceName'] != null ? prospect['sourceName'] : 'N/A') + '</p>';
    }
    smsBody += (prospect['corporateName'] != null ? ('<p><strong>' + prospect['corporateName'] + '</strong></p>') : '');
    smsBody += (prospect['communityName'] != null ? ('<p><strong>' + prospect['communityName'] + '</strong></p>') : '');
    smsBody += (prospect['floorplanTitle'] != null ? ('<p>' + prospect['floorplanTitle'] + '</p>') : '');
    smsBody += '<div class="classification sms-history" id="sms-history' + prospect['smsTrackingId'] + '">';
    smsBody += '<div id="previousMessagesSMS' + prospect['smsTrackingId'] + '" class="loading" style="display:none;">';
    smsBody += '</div>';
    smsBody += '<p class=\'them\'>' + (prospect['content'] != null ? prospect['content'] : 'N/A') + '</p>';
    smsBody += (prospect['createdOnString'] != null ? ('<p class=\'them-details\'>' + prospect['createdOnString'] + '</p>') : '');
    smsBody += '</div>';
    smsBody += '<div id="replyListSMS' + prospect['smsTrackingId'] + '" class="replies" style="display:none;">';
    smsBody += '</div>';
    smsBody += '<p><strong>Classification:</strong> ' + (prospect['classification'] != null ? prospect['classification'] : 'None') + '</p>';
    smsBody += '<p><strong>Classified By:</strong> ' + (prospect['classifiedBy'] != null ? prospect['classifiedBy'] : 'N/A') + '</p>';
    smsBody += '<p><strong>Classified On:</strong> ' + (prospect['classifiedOnString'] != null ? prospect['classifiedOnString'] : 'N/A') + '</p>';
    smsBody += '<p><strong>Notes:</strong> ' + (prospect['notes'] != null ? prospect['notes'] : 'N/A') + '</p>';
    smsBody += '</div>';
    if (hasSMSReplyAccess) {
        smsBody += '<form class="updateCall" id="smsReplyForm' + prospect['smsTrackingId'] + '" action="#" method="POST">';
        smsBody += '<h4>Reply to Message</h4>';
        smsBody += '<ul>';
        smsBody += '<li>';
        smsBody += '<textarea id="smsReplyValue' + prospect['smsTrackingId'] + '" onkeyup="$(\'#smsReply' + prospect['smsTrackingId'] + '\').prop(\'disabled\',false);" rows="2" cols="50" placeholder=\'Reply\'></textarea>';
        smsBody += '</li>';
        smsBody += '</ul>';
        smsBody += '<input id="smsReply' + prospect['smsTrackingId'] + '" class="accent-btn" type="submit" value="Reply" disabled="disabled"/>';
        smsBody += '</form>';
    }
    smsBody += '<form class="updateCall" id="smsDetailsForm' + prospect['smsTrackingId'] + '" action="#" method="POST">';
    smsBody += '<h4>Update Message Information</h4>';
    smsBody += '<ul>';
    smsBody += '<li class=\'inline-form-input\'>';
    smsBody += '<label for="smsClassificationValue' + prospect['smsTrackingId'] + '">Classification:</label>';
    smsBody += '<select id="smsClassificationValue' + prospect['smsTrackingId'] + '" onchange="$(\'#smsDetails' + prospect['smsTrackingId'] + '\').prop(\'disabled\',false);">';
    smsBody += '<option value="">Choose Classification</option>';
    for (var cc = 0; cc < callClassifications.length; cc++) {
        var classification = callClassifications[cc];
        smsBody += '<option value="' + classification['classificationId'] + '" ' + (prospect['classificationId'] != null && prospect['classificationId'] == classification['classificationId'] ? 'selected="selected"' : '') + '>' + classification['name'] + '</option>';
    }
    smsBody += '</select>';
    smsBody += '</li>';
    smsBody += '<li>';
    smsBody += '<label for="smsNotesValue' + prospect['smsTrackingId'] + '">Notes:</label>';
    smsBody += '<textarea id="smsNotesValue' + prospect['smsTrackingId'] + '" onkeyup="$(\'#smsDetails' + prospect['smsTrackingId'] + '\').prop(\'disabled\',false);" rows="2" cols="50" placeholder=\'Notes\'>' + (prospect['notes'] ? prospect['notes'] : '') + '</textarea>';
    smsBody += '</li>';
    smsBody += '</ul>';
    smsBody += '<input id="smsDetails' + prospect['smsTrackingId'] + '" class="accent-btn" type="submit" value="Update" disabled="disabled"/>';
    smsBody += '<span id="smsDetailsSuccess' + prospect['smsTrackingId'] + '" class="AVAILABLE" style="margin-left:.5em;display:none;">Updated!</span>';
    smsBody += '</form>';
    smsBody += '<script type="text/javascript">';
    smsBody += '$("#smsDetailsForm' + prospect['smsTrackingId'] + '").submit(function() {';
    smsBody += '$("#smsDetails' + prospect['smsTrackingId'] + '").prop(\'disabled\',true);';
    smsBody += 'var request = $.ajax({';
    smsBody += 'url: "/rapi/rvp/sms/update-sms-details?sti=' + prospect['smsTrackingId'] + '&cci="+$("#smsClassificationValue' + prospect['smsTrackingId'] + '").val()+"&sn="+encodeURIComponent($("#smsNotesValue' + prospect['smsTrackingId'] + '").val()),';
    smsBody += 'type: "PUT",';
    smsBody += 'dataType: "text"';
    smsBody += '});';
    smsBody += 'request.done(function(msg) {';
    smsBody += '$("#smsDetailsSuccess' + prospect['smsTrackingId'] + '").show().delay(2000).fadeOut();';
    smsBody += '});';
    smsBody += 'request.fail(function(jqXHR, textStatus) {';
    smsBody += 'if (jqXHR.responseJson && jqXHR.responseJson.message) {';
    smsBody += 'alert(jqXHR.responseJson.message);';
    smsBody += '} else {';
    smsBody += 'alert("An error occurred during classification update. Please try again.");';
    smsBody += '}';
    smsBody += '});';
    smsBody += 'return false;';
    smsBody += '});';
    smsBody += '$("#smsReplyForm' + prospect['smsTrackingId'] + '").submit(function() {';
    smsBody += '$("#smsReply' + prospect['smsTrackingId'] + '").prop(\'disabled\',true);';
    smsBody += 'var request = $.ajax({';
    smsBody += 'url: "/rapi/rvp/sms/send-sms-reply?o=' + prospect['smsTrackingId'] + '&b="+encodeURIComponent($("#smsReplyValue' + prospect['smsTrackingId'] + '").val()),';
    smsBody += 'type: "POST",';
    smsBody += 'dataType: "text"';
    smsBody += '});';
    smsBody += 'request.done(function(msg) {';
    smsBody += 'var replyHtml = "<p class=\'you\'>" + $("#smsReplyValue' + prospect['smsTrackingId'] + '").val() + "</p>";';
    smsBody += 'replyHtml += "<p class=\'you-details\'><strong>You</strong> Just Now</p>";';
    smsBody += 'replyHtml += "</div>";';
    smsBody += '$("#replyListSMS' + prospect['smsTrackingId'] + '").append(replyHtml);';
    smsBody += 'if ($("#replyList' + prospect['smsTrackingId'] + '").is(":hidden")) {';
    smsBody += '$("#replyList' + prospect['smsTrackingId'] + '").show();';
    smsBody += '}';
    smsBody += '$("#smsReplyValue' + prospect['smsTrackingId'] + '").val("");';
    smsBody += '$("#sms-history' + prospect['smsTrackingId'] + '").animate({ scrollTop: $("#sms-history' + prospect['smsTrackingId'] + '").prop("scrollHeight") }, "fast")';
    smsBody += '});';
    smsBody += 'request.fail(function(jqXHR, textStatus) {';
    smsBody += 'if (jqXHR.responseJSON && jqXHR.responseJSON.message) {';
    smsBody += 'alert(jqXHR.responseJSON.message);';
    smsBody += '} else {';
    smsBody += 'alert("An error occurred during reply. Please try again.");';
    smsBody += '}';
    smsBody += '});';
    smsBody += 'return false;';
    smsBody += '});';
    smsBody += 'var smsDetails = {"fs" : "' + prospect['smsFrom'] + '", "sd" : "' + prospect['createdOnMillis'] + '", "sti" : "' + prospect['smsTrackingId'] + '", "a": "' + prospect['applicationId'] + '"};';
    smsBody += 'smsDetailsMap["SMS' + prospect['smsTrackingId'] + '"] = smsDetails;';
    smsBody += '</script>';
    smsBody += '</div>';
    smsBody += '</div>';
    return smsBody;
}

function getMonth(month) {
    switch (month) {
        case 0:
            return 'Jan';
        case 1:
            return 'Feb';
        case 2:
            return 'Mar';
        case 3:
            return 'Apr';
        case 4:
            return 'May';
        case 5:
            return 'Jun';
        case 6:
            return 'Jul';
        case 7:
            return 'Aug';
        case 8:
            return 'Sep';
        case 9:
            return 'Oct';
        case 10:
            return 'Nov';
        case 11:
            return 'Dec';
    }
}

var smsDetailsMap = {};

function loadPreviousSMS(smsUniqueId) {
    $('#previousMessages' + smsUniqueId).removeClass('loading');
    var smsDetails = smsDetailsMap[smsUniqueId],
        smsFrom = smsDetails['fs'],
        smsDate = smsDetails['sd'],
        smsTrackingId = smsDetails['sti'],
        smsApplicationId = smsDetails['a'];

    var request = $.ajax({
        url: '/rapi/rvp/sms/get-recent-sms-chain?fs=' + encodeURIComponent(smsFrom) + '&sd=' + smsDate + '&sti=' + smsTrackingId + '&a=' + smsApplicationId,
        type: 'GET',
        dataType: 'json'
    });

    request.done(function (msg) {
        if (msg != null) {
            var chain = msg['chain'];
            if (chain.length > 0) {
                var html = '';
                for (var i = 0; i < chain.length; i++) {
                    var sms = chain[i];
                    html += '<p class="them">' + sms['content'] + '</p>';
                    html += '<p class="them-details">' + sms['createdOnString'] + '</p>';
                    if (sms['smsReplyList'].length > 0) {
                        for (var j = 0; j < sms["smsReplyList"].length; j++) {
                            var reply = sms['smsReplyList'][j];
                            html += '<p class="you">' + reply['reply'] + '</p>';
                            html += '<p class="you-details"><strong>' + reply['replyBy'] + '</strong> on ' + reply['replyOnString'] + '</p>';
                        }
                    }
                    html += '<p class=\'clearFix\'>&nbsp;</p>';
                    html += '</div>';
                }
                $('#previousMessages' + smsUniqueId).append(html);
                $('#previousMessages' + smsUniqueId).show();
            }
            var replies = msg['replies'];
            if (replies.length > 0) {
                var replyHtml = '';
                for (var i = 0; i < replies.length; i++) {
                    var reply = replies[i];
                    replyHtml += '<p class="you">' + reply['reply'] + '</p>';
                    replyHtml += '<p class=\'you-details\'><strong>' + reply['replyBy'] + '</strong> on ' + reply['replyOnString'] + '</em></p>';
                    replyHtml += '</div>';
                }
                $('#replyList' + smsUniqueId).append(replyHtml);
                $('#replyList' + smsUniqueId).show();
            }
            $('#sms-history' + smsUniqueId).animate({scrollTop: $('#sms-history' + smsUniqueId).prop('scrollHeight')}, 'fast');
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#previousMessages' + smsUniqueId).addClass('loading');
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message + ', please contact your Client Success Manager for assistance.');
        } else {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        }
    });
}

function getRecentSms() {
    var currentTime = (new Date()).getTime();
    var smsDate = currentTime - 30000;
    if (sessionStorage.getItem('SMSFetchDate')) {
        smsDate = sessionStorage.getItem('SMSFetchDate');
    }
    var request = $.ajax({
        url: '/rapi/rvp/sms/get-recent-sms?sd=' + smsDate,
        type: 'GET',
        dataType: 'json'
    });
    request.done(function (msg) {
        var recents = {};
        if (sessionStorage.getItem('SMSRecents')) {
            recents = JSON.parse(sessionStorage.getItem('SMSRecents'));
        }
        if (msg != null) {
            for (var i = 0; i < msg.length; i++) {
                recents[msg[i]['smsTrackingId']] = msg[i];
            }
            sessionStorage.setItem('SMSRecents', JSON.stringify(recents));
        }
        checkMissedMessages();
        sessionStorage.setItem('SMSFetchDate', currentTime);
        setTimeout(getRecentSms, 30000);//30 seconds
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message + ', please contact your Client Success Manager for assistance.');
        } else {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        }
    });
}

function checkMissedMessages() {
    var recents = {};
    if (sessionStorage.getItem('SMSRecents')) {
        recents = JSON.parse(sessionStorage.getItem('SMSRecents'));
    }
    var missedCount = Object.keys(recents).length;
    $('.recentSMSCount').text(missedCount);
    if (missedCount > 0) {
        $('#recentSMSAlert').show();
        if ($.magnificPopup.instance && $.magnificPopup.instance.isOpen) {
            loadRecentSMS();
        }
    } else {
        $('#recentSMSAlert').hide();
    }
}

function loadRecentSMS() {
    if (sessionStorage.getItem('SMSRecents')) {
        var recents = JSON.parse(sessionStorage.getItem('SMSRecents'));
        var recentTexts = Object.values(recents);
        for (var i = 0; i < recentTexts.length; i++) {
            var text = recentTexts[i];
            if (!$('#unread-sms-list #unread-sms-' + text['smsTrackingId']).length) {
                var html = '<li id="unread-sms-' + text['smsTrackingId'] + '">';
                html += '<p class=\'meta-data\'>';
                html += '<a class=\'clear accent-inline-btn\' href="#" onclick="removeRecentSMS(\'' + text['smsTrackingId'] + '\');return false;">Clear</a>';
                html += '<em>' + (text['corporateName'] != null ? (text['corporateName']) : '');
                html += (text['communityName'] != null ? (text['communityName']) : '') + '</em>';
                html += '<strong>(' + text['smsFrom'].substring(2, 5) + ') ' + text['smsFrom'].substring(5, 8) + '-' + text['smsFrom'].substring(8, 12) + '</strong>';
                html += '<span>';
                html += text['createdOnString'] + '</span>';
                html += '</p>';
                var tmpContent = '<div>' + text['content'] + '</div>';
                html += '<p class=\'preview\'><span class=\'content\'>' + $(tmpContent).text() + '</span>';
                html += '<a href="#" onclick="showRecentSMSDetails(\'' + text['smsTrackingId'] + '\', \'' + text['createdOnMillis'] + '\', \'' + text['smsFrom'] + '\', \'' + text['applicationId'] + '\');return false;">See More <img src=\'/assets/images/user/v2/downArrowOrange.svg\' alt=\'\'/></a>';
                html += '</p>';
                html += '<div class=\'full-details\' id="unread-sms-details-' + text['smsTrackingId'] + '" style=\'display:none;\'>';
                html += '<div id="unread-previous-messages' + text['smsTrackingId'] + '" class="loading" style="display:none;">';
                html += '</div>';
                html += '<p class=\'them\'>' + text['content'] + '</p>';
                html += '<p class=\'them-details\'>' + text['createdOnString'] + '</p>';
                html += '<div id=\'unread-new-sms-replies-' + text['smsTrackingId'] + '\' style=\'display:none;\'>';
                html += '</div>';
                html += '<form id="smsPopupReplyForm' + text['smsTrackingId'] + '" action="#" method="POST" onsubmit="return submitPopupReply(\'' + text['smsTrackingId'] + '\');">';
                html += '<textarea id="smsPopupReplyValue' + text['smsTrackingId'] + '" onkeyup="$(\'#smsPopupReply' + text['smsTrackingId'] + '\').prop(\'disabled\',false);" rows="2" cols="50" placeholder=\'Reply\'></textarea>';
                html += '<input id="smsPopupReply' + text['smsTrackingId'] + '" class="accent-inline-btn" style="margin-top:1em;" type="submit" value="Reply" disabled="disabled"/>';
                html += '</form>';
                html += '</div>';
                html += '</li>';
                $('#unread-sms-list').prepend(html);
            }
        }
    }
}

function showRecentSMSDetails(smsTrackingId, smsDate, smsFrom, applicationId) {
    $('#unread-sms-' + smsTrackingId + ' .preview').slideUp();
    $('#unread-sms-details-' + smsTrackingId).slideDown();
    var request = $.ajax({
        url: '/rapi/rvp/sms/get-recent-sms-chain?fs=' + encodeURIComponent(smsFrom) + '&sd=' + smsDate + '&sti=' + smsTrackingId + '&a=' + applicationId,
        type: 'GET',
        dataType: 'json'
    });
    request.done(function (msg) {
        if (msg != null) {
            var chain = msg['chain'];
            if (chain.length > 0) {
                var html = '';
                for (var i = 0; i < chain.length; i++) {
                    var sms = chain[i];
                    html += '<p class="them">' + sms['content'] + '</p>';
                    html += '<p class="them-details">' + sms['createdOnString'] + '</p>';
                    if (sms['smsReplyList'].length > 0) {
                        for (var j = 0; j < sms["smsReplyList"].length; j++) {
                            var reply = sms['smsReplyList'][j];
                            html += '<p class="you">' + reply['reply'] + '</p>';
                            html += '<p class="you-details"><strong>' + reply['replyBy'] + '</strong> on ' + reply['replyOnString'] + '</p>';
                        }
                    }
                    html += '<p class=\'clearFix\'>&nbsp;</p>';
                    html += '</div>';
                }
                $('#unread-previous-messages' + smsTrackingId).append(html);
                $('#unread-previous-messages' + smsTrackingId).show();
            }
            var replies = msg['replies'];
            if (replies.length > 0) {
                var replyHtml = '';
                for (var i = 0; i < replies.length; i++) {
                    var reply = replies[i];
                    replyHtml += '<p class="you">' + reply['reply'] + '</p>';
                    replyHtml += '<p class=\'you-details\'><strong>' + reply['replyBy'] + '</strong> on ' + reply['replyOnString'] + '</em></p>';
                    replyHtml += '</div>';
                }
                $('#unread-new-sms-replies-' + smsTrackingId).append(replyHtml);
                $('#unread-new-sms-replies-' + smsTrackingId).show();
            }
            $('#unread-sms-details-' + smsTrackingId).animate({scrollTop: $('#unread-sms-details-' + smsTrackingId).prop('scrollHeight')}, 'fast');
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#previousMessages' + smsUniqueId).addClass('loading');
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message + ', please contact your Client Success Manager for assistance.');
        } else {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        }
    });
}

function submitPopupReply(smsTrackingId) {
    $('#smsPopupReply' + smsTrackingId).prop('disabled', true);
    var request = $.ajax({
        url: '/rapi/rvp/sms/send-sms-reply?o=' + smsTrackingId + '&b=' + encodeURIComponent($('#smsPopupReplyValue' + smsTrackingId).val()),
        type: 'POST',
        dataType: 'text'
    });
    request.done(function (msg) {
        removeRecentSMS(smsTrackingId);
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
            alert(jqXHR.responseJSON.message);
        } else {
            alert('An error occurred during reply. Please try again.');
        }
    });
    return false;
}

function removeRecentSMS(smsTrackingId) {
    var recents = JSON.parse(sessionStorage.getItem('SMSRecents'));
    $('#unread-sms-' + smsTrackingId).remove();
    delete recents[smsTrackingId];
    sessionStorage.setItem('SMSRecents', JSON.stringify(recents));
    var missedCount = Object.keys(recents).length;
    $('.recentSMSCount').text(missedCount);
    if (missedCount == 0) {
        $.magnificPopup.close();
        $('#recentSMSAlert').hide();
    }
}

function loadResidentApplications(interval, isReset) {
    if ($('#moreProspects').is(':visible') && !$('#moreProspects').hasClass('loading')) {
        $('#moreProspects').addClass('loading');
        var request = $.ajax({
            url: '/rapi/rvp/resident-application/get-resident-applications?lpt=' + lastProspectTimestamp + '&i=' + interval,
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            parseResidentApplications(msg);
            if (msg.length > 0) {
                lastProspectTimestamp = msg[msg.length - 1]['createdOnMillis'];
                $('#moreProspects').removeClass('loading');
            } else {
                $('#moreProspects').hide();
                $('#noMoreProspects').show();
                $('#noMoreProspects').addClass('loaded');
            }
            if (isReset) {
                postClearEmailSearch();
            }
        });
        request.fail(function (jqXHR, textStatus) {
            if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                alert(jqXHR.responseJSON.message);
            } else {
                alert('An error occurred, please contact your Client Success Manager for assistance.');
            }
        });
    }
}

function parseResidentApplications(msg) {
    var currentYear = new Date().getFullYear();
    for (var i = 0; i < msg.length; i++) {
        var app = msg[i];
        var appDate = new Date(app['createdOnMillis']);
        var appHtml = '<div id="emailIntro' + app['residentApplicationId'] + '" class="intro" onclick="loadApplication(\'' + app['residentApplicationId'] + '\');">';
        appHtml += '<span class="date">' + getMonth(appDate.getMonth()) + ' ' + appDate.getDate() + (currentYear != appDate.getFullYear() ? (', ' + appDate.getFullYear()) : '') + '</span>';
        appHtml += '<h4 class="from">' + app['name'] + '</h4>';
        appHtml += '<p class="message subject">' + app['subject'] + '</p>';
        appHtml += '</div>';
        $('#moreProspects').before(appHtml);
        var appBody = '<div class="emailFullContent applicationFullContent" id="email' + app['residentApplicationId'] + '" style="display:none;">';
        appBody += '<img class="loading-gif" src="/assets/images/user/rvp/RentVisionLoading.gif" alt="Loading..."/>';
        appBody += '</div>';
        $('.emailContent').append(appBody);
    }
}

function loadApplication(residentApplicationId) {
    $('.intro').removeClass('selected');
    $('#emailIntro' + residentApplicationId).addClass('selected');
    $('.emailFullContent').hide();
    $('#email' + residentApplicationId).show();
    if (!$('#email' + residentApplicationId).hasClass('loaded')) {
        var request = $.ajax({
            url: '/rapi/rvp/resident-application/get-resident-application?ra=' + residentApplicationId,
            type: 'GET',
            dataType: 'html'
        });
        request.done(function (msg) {
            $('#email' + residentApplicationId).html(msg);
            $('#email' + residentApplicationId).addClass('loaded').find('.tooltip:not(.no-delay)').tooltip({
                show: {delay: TOOLTIP_DELAY}
            });

            triggerContactLoadingScrollCheck();
        });
        request.fail(function (jqXHR, textStatus) {
            $('#email' + residentApplicationId).html('<h3>Not Found</h3><p>Application not found, please contact your Client Success Manager for assistance.</p>');
        });
    }
}

function loadColeasors(emailTrackingId) {
    var request = $.ajax({
        url: '/rapi/rvp/lease/get-coleasors?l=' + emailTrackingId + '&a=' + $('#application' + emailTrackingId).val(),
        type: 'GET',
        dataType: 'json'
    });
    request.done(function (data) {
        var tmpArray = leasors[emailTrackingId + ''];
        $('#coleasors' + emailTrackingId).removeClass('loading');
        if (data.length > 0) {
            var html = '';
            for (var i = 0; i < data.length; i++) {
                var coleasor = data[i];
                html += '<div id="customer' + coleasor['customerId'] + '">';
                html += buildCustomerData(coleasor, emailTrackingId);
                html += '<input class="inverted-accent-inline-btn" type="button" value="Delete ' + coleasor.name + '" onclick="deleteColeasor(' + emailTrackingId + ',' + coleasor.customerId + ',\'' + coleasor.name + '\');return false;">';
                html += '</div>';
                tmpArray.push(coleasor['customerId']);
            }
            $('#coleasors' + emailTrackingId).append(html);
            leasors[emailTrackingId + ''] = tmpArray;
        }
        $('#coleasors' + emailTrackingId).show();
        $('#coleasors' + emailTrackingId + ' .tooltip').tooltip({
            show: {delay: TOOLTIP_DELAY}
        });
        loadLeaseContacts(emailTrackingId);
    });
    request.fail((request) => {
        if (request.responseJSON && request.responseJSON.message) { // make sure there is a response json and that it has a message
            alert(request.responseJSON.message);
        } else {
            alert('An error occurred while trying to get Co-Leasor. Please contact your Client Success Manager for assistance.');
        }
    });
}

function deleteColeasor(leaseId, customerId, name) {

    var response = confirm('Are you sure you want to delete ' + name + ' ?');

    if (response) {
        var request = $.ajax({
            url: '/rapi/rvp/lease/delete-coleasor?leaseId=' + leaseId + '&customerId=' + customerId,
            type: 'DELETE',
            dataType: 'text'
        });
        request.done(function () {
            $('#customer' + customerId).hide('slow');
        });
        request.fail((request) => {
            if (request.responseJSON && request.responseJSON.message) { // make sure there is a response json and that it has a message
                alert(request.responseJSON.message + ' Please contact your Client Success Manager for assistance.');
            } else {
                alert('An error occurred while trying to delete Co-Leasor. Please contact your Client Success Manager for assistance.');
            }
        });
    }
}

function buildCustomerData(customer, leaseId) {
    var html = '<h4 class="editable"><a href="#" onclick="loadCustomer(\'' + $('#application' + leaseId).val() + '\', \'' + leaseId + '\', \'' + customer['customerId'] + '\');return false;"><span>' + (customer['name'] != null ? customer['name'] : (customer['firstName'] + ' ' + customer['lastName'])) + '</span> <img src="/assets/images/user/rvp/Edit.svg" class="tooltip" title="Edit" alt="Edit"/></a></h4>';
    var contactInfo = customer['contactInfo'];
    if (contactInfo['EMAIL'] != null && contactInfo['EMAIL'].length > 0) {
        html += '<p><strong>Email:</strong>';
        for (var j = 0; j < contactInfo["EMAIL"].length; j++) {
            html += ' ' + contactInfo['EMAIL'][j]['label'] + ': ' + contactInfo['EMAIL'][j]['value'];
            if (j < contactInfo['EMAIL'].length - 1) {
                html += ',';
            }
        }
        html += '</p>';
    }
    if (contactInfo['PHONE'] != null && contactInfo['PHONE'].length > 0) {
        html += '<p><strong>Phone:</strong>';
        for (var j = 0; j < contactInfo["PHONE"].length; j++) {
            var phoneValue = contactInfo['PHONE'][j]['value'];
            if (phoneValue.indexOf('(') != 0) {
                phoneValue = '(' + phoneValue.substring(0, 3) + ') ' + phoneValue.substring(4, 12);
            }
            html += ' ' + contactInfo['PHONE'][j]['label'] + ': ' + phoneValue;
            if (j < contactInfo['PHONE'].length - 1) {
                html += ',';
            }
        }
        html += '</p>';
    }
    return html;
}

function loadLeaseContacts(emailTrackingId) {
    $('#customerContact' + emailTrackingId).hide();
    $('#customerContact' + emailTrackingId).empty();
    $('#customerContact' + emailTrackingId).append('<h3>Communication</h3>');
    var tmpArray = leasors[emailTrackingId + ''];
    var customerList = '';
    for (var i = 0; i < tmpArray.length; i++) {
        customerList += tmpArray[i] + ',';
    }
    var request = $.ajax({
        url: '/rapi/rvp/customer/get-customer-contact?c=' + customerList + '&a=' + $('#application' + emailTrackingId).val(),
        type: 'GET',
        dataType: 'json'
    });
    request.done(function (msg) {
        if (msg.length > 0) {
            var currentYear = new Date().getFullYear();
            var html = '';
            for (var i = 0; i < msg.length; i++) {
                var prospect = msg[i];
                if (prospect['emailTrackingId'] != null) {
                    var emailContent = prospect['content'];
                    var emailDate = new Date(prospect['createdOnMillis']);
                    if (prospect['emailType'] == 'LEAD') {
                        var nameSubstringIndex = emailContent.indexOf('<b>Name:</b>');
                        var emailName = prospect['fromEmail'];
                        if (nameSubstringIndex > 0) {
                            var nameFirstPart = emailContent.substring(nameSubstringIndex + 12);
                            if (nameFirstPart.indexOf('<') > 0) {
                                emailName = nameFirstPart.substring(0, nameFirstPart.indexOf('<'));
                            }
                        }
                        var phoneSubstringIndex = emailContent.indexOf('<b>Phone Number:</b>');
                        var phone = '';
                        if (phoneSubstringIndex > 0) {
                            var phoneFirstPart = emailContent.substring(phoneSubstringIndex + 20);
                            phone = phoneFirstPart.substring(0, phoneFirstPart.indexOf('<'));
                        }
                        var subject = 'Contact Request';
                        if (prospect['communityName'] != null && prospect['communityName'] != 'Missing') {
                            subject = prospect['communityName'];
                        } else if (prospect['corporateName'] != null && prospect['corporateName'] != 'Missing') {
                            subject = prospect['corporateName'];
                        }
                        html += '<div id="emailIntroEMAIL' + prospect['emailTrackingId'] + '" class="intro" onclick="$(\'#emailEMAIL' + prospect['emailTrackingId'] + '\').slideToggle();">';
                        html += '<span class="date">' + getMonth(emailDate.getMonth()) + ' ' + emailDate.getDate() + (currentYear != emailDate.getFullYear() ? (', ' + emailDate.getFullYear()) : '') + '</span>';
                        html += '<h4 class="from">' + $.trim(emailName) + '</h4>';
                        html += '<p class="message subject">' + subject + '</p>';
                        if (prospect['floorplanTitle'] != null && prospect['floorplanTitle'] != 'Missing') {
                            html += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                        }
                        html += '<img src="/assets/images/user/rvp/Email.svg" alt=""/>';
                        if ($.trim(phone).length > 0) {
                            html += '<p class="message">' + $.trim(phone) + '</p>';
                        }
                        if (prospect['sourceName'] != null) {
                            html += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                        }
                        html += '<p class="clearFix">&nbsp;</p>';
                        html += '</div>';
                        html += getProspectEmailContent(prospect, emailContent);
                    } else {
                        var name = null;
                        for (var j = 0; j < possibleNames.length; j++) {
                            var possibleName = possibleNames[j];
                            var substringIndex = emailContent.indexOf(possibleName);
                            if (substringIndex > 0) {
                                var nameFirstPart = emailContent.substring(substringIndex + possibleName.length);
                                if (nameFirstPart.indexOf('<') > 0) {
                                    name = nameFirstPart.substring(0, nameFirstPart.indexOf('<'));
                                }
                                break;
                            }
                        }
                        var phone = null;
                        for (var j = 0; j < possiblePhones.length; j++) {
                            var possiblePhone = possiblePhones[j];
                            var substringIndex = emailContent.indexOf(possiblePhone);
                            if (substringIndex > 0) {
                                var phoneFirstPart = emailContent.substring(substringIndex + possiblePhone.length);
                                if (phoneFirstPart.indexOf('<') > 0) {
                                    phone = phoneFirstPart.substring(0, phoneFirstPart.indexOf('<'));
                                }
                                break;
                            }
                        }
                        var subject = 'Maintenance Request';
                        if (prospect['communityName'] != null && prospect['communityName'] != 'Missing') {
                            subject = prospect['communityName'];
                        } else if (prospect['corporateName'] != null && prospect['corporateName'] != 'Missing') {
                            subject = prospect['corporateName'];
                        }
                        html += '<div id="emailIntroEMAIL' + prospect['emailTrackingId'] + '" class="intro" onclick="$(\'#emailEMAIL' + prospect['emailTrackingId'] + '\').slideToggle();">';
                        html += '<span class="date">' + getMonth(emailDate.getMonth()) + ' ' + emailDate.getDate() + (currentYear != emailDate.getFullYear() ? (', ' + emailDate.getFullYear()) : '') + '</span>';
                        html += '<h4 class="from">' + (name != null ? $.trim(name) : prospect['fromEmail']) + '</h4>';
                        html += '<p class="message subject">' + subject + '</p>';
                        if (phone != null && $.trim(phone).length > 0) {
                            html += '<p class="message">' + $.trim(phone) + '</p>';
                        }
                        if (prospect['emailType'] != 'LEAD') {
                            html += '<p class="message">' + prospect['subject'] + '</p>';
                        }
                        if (prospect['sourceName'] != null) {
                            html += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                        }
                        html += '</div>';
                        html += '<div class="emailFullContent" id="emailEMAIL' + prospect['emailTrackingId'] + '" style="display:none;">';
                        html += '<p><strong>Received:</strong> ' + (prospect['createdOnString'] != null ? prospect['createdOnString'] : 'N/A') + '</p>';
                        html += emailContent.replace(/width="600"/g, 'width="100%"').replace(/width="580"/g, 'width="100%"');
                        html += '</div>';
                    }
                } else if (prospect['callTrackingId'] != null) {
                    var callDate = new Date(prospect['createdOnMillis']);
                    var subject = 'Phone Call';
                    var callFrom = prospect['callFrom'] == null ? 'N/A' : '(' + prospect['callFrom'].substring(2, 5) + ') ' + prospect['callFrom'].substring(5, 8) + '-' + prospect['callFrom'].substring(8, 12);
                    if (prospect['communityName'] != null) {
                        subject = prospect['communityName'];
                    } else if (prospect['corporateName'] != null) {
                        subject = prospect['corporateName'];
                    }
                    html += '<div id="emailIntroCALL' + prospect['callTrackingId'] + '" class="intro" onclick="$(\'#emailCALL' + prospect['callTrackingId'] + '\').slideToggle();">';
                    html += '<span class="date">' + getMonth(callDate.getMonth()) + ' ' + callDate.getDate() + (currentYear != callDate.getFullYear() ? (', ' + callDate.getFullYear()) : '') + '</span>';
                    html += '<h4 class="from">' + (prospect['fromName'] != null ? prospect['fromName'].toLowerCase() : callFrom) + '</h4>';
                    html += '<p class="message subject">' + subject + '</p>';
                    if (prospect['floorplanTitle'] != null) {
                        html += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                    }
                    html += '<img src="/assets/images/user/rvp/Phone.svg" alt=""/>';
                    html += '<span class="callDuration">' + parseInt(prospect['callDurationInSeconds'] / 60) + ':' + (prospect['callDurationInSeconds'] % 60 < 10 ? '0' : '') + prospect['callDurationInSeconds'] % 60 + '</span>';
                    if (prospect['fromName'] != null) {
                        html += '<p class="message">' + callFrom + '</p>';
                    }
                    if (prospect['sourceName'] != null) {
                        html += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                    }
                    html += '<p class="clearFix">&nbsp;</p>';
                    html += '</div>';
                    html += getProspectCallContent(prospect);
                } else if (prospect['smsTrackingId'] != null) {
                    var smsDate = new Date(prospect['createdOnMillis']);
                    var subject = 'Text Message';
                    var smsFrom = prospect['smsFrom'] == null ? 'N/A' : '(' + prospect['smsFrom'].substring(2, 5) + ') ' + prospect['smsFrom'].substring(5, 8) + '-' + prospect['smsFrom'].substring(8, 12);
                    if (prospect['communityName'] != null) {
                        subject = prospect['communityName'];
                    } else if (prospect['corporateName'] != null) {
                        subject = prospect['corporateName'];
                    }
                    html += '<div id="emailIntroSMS' + prospect['smsTrackingId'] + '" class="intro" onclick="$(\'#emailSMS' + prospect['smsTrackingId'] + '\').slideToggle();">';
                    html += '<span class="date">' + getMonth(smsDate.getMonth()) + ' ' + smsDate.getDate() + (currentYear != smsDate.getFullYear() ? (', ' + smsDate.getFullYear()) : '') + '</span>';
                    html += '<h4 class="from">' + smsFrom + '</h4>';
                    html += '<p class="message subject">' + subject + '</p>';
                    if (prospect['floorplanTitle'] != null) {
                        html += '<p class="message floorplan">' + prospect['floorplanTitle'] + '</p>';
                    }
                    html += '<img src="/assets/images/user/rvp/Text.svg" alt=""/>';
                    if (prospect['sourceName'] != null) {
                        html += '<p class="message">Source: <span' + (prospect['sourceName'].indexOf('RentVision') >= 0 ? ' style="color:#1e988a;"' : '') + '>' + prospect['sourceName'] + '</span></p>';
                    }
                    html += '<p class="clearFix">&nbsp;</p>';
                    html += '</div>';
                    html += getProspectSmsContent(prospect);
                }
            }
            $('#customerContact' + emailTrackingId).append(html);
            $('#customerContact' + emailTrackingId).show();

            $('#customerContact' + emailTrackingId + ' select').each(function () {
                $(this).select2({dropdownAutoWidth: true, width: 'auto'});
            });
        }
    });
    request.fail((jqXHR) => {
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message);
        } else {
            alert('An error occurred while trying to get customer contact information. Please try again.');
        }
    });
}

var calculatedScrollTop = 0;

function navigateEmail(e) {
    e = e || window.event;
    if ($('#filterBy').is(':focus') || $('#filterApplicationId').is(':focus')) {
        return;
    }
    if ($('#emailSearch').is(':focus') && e.which != 38 && e.which != 40) {
        return;
    }

    var shouldScroll = false;
    if (e.which == 38) {
        var elem = $('.intro.selected');
        var prevElem = elem.prev();
        while (prevElem.length > 0 && prevElem.is(':hidden')) {
            prevElem = prevElem.prev();
        }
        if (prevElem.length > 0) {
            $('.intro').removeClass('selected');
            prevElem.addClass('selected');
            calculatedScrollTop -= $('.intro.selected').outerHeight();
            prevElem.click();
        }
        e.preventDefault();
        shouldScroll = true;
    } else if (e.which == 40) {
        var elem = $('.intro.selected');
        var nextElem = elem.next();
        while (nextElem.length > 0 && nextElem.is(':hidden')) {
            nextElem = nextElem.next();
        }
        if (nextElem.length > 0 && nextElem.attr('id') != 'moreProspects' && nextElem.attr('id') != 'noMoreProspects') {
            $('.intro').removeClass('selected');
            nextElem.addClass('selected');
            calculatedScrollTop += $('.intro.selected').outerHeight();
            nextElem.click();
        }
        e.preventDefault();
        shouldScroll = true;
    }
    if (shouldScroll) {
        if (calculatedScrollTop < 0) {
            calculatedScrollTop = 0;
        }
        $('.intro.selected').parent().animate({scrollTop: calculatedScrollTop}, 100);
    }
}

function emailSearchDB(searchInput, clearButton, intro, content, noResults, type, paging) {
    if ($('#noMoreProspects').length == 0 || $('#noMoreProspects').hasClass('loaded')) {
        $('#noMoreProspects').hide();
        emailSearch(searchInput, clearButton, intro, content, noResults);
    } else {
        var searchValue = $.trim($(searchInput).val()).toLowerCase();
        var filterValue = $.trim($('#filterApplicationId').val());
        if (searchValue.length > 0 || filterValue.length > 0) {
            $(noResults).hide();
            $('.contact-content .contact-card').show();
            $('#moreProspects').hide();
            $('#noMoreProspects').hide();
            if (paging) {
                if ($('#moreSearchProspects').is(':visible') && !$('#moreSearchProspects').hasClass('loading')) {
                    $('#moreSearchProspects').addClass('loading');
                } else {
                    return;
                }
            } else {
                lastSearchInterval = 7;
                lastSearchProspectTimestamp = new Date().getTime() + (new Date().getTimezoneOffset() * 60 * 1000);
                $('#moreSearchProspects').addClass('loading');
                $('#moreSearchProspects').show();
                $('#noMoreSearchProspects').hide();
                $(intro).each(function () {
                    $(this).remove();
                });
                $(content).each(function () {
                    $(this).remove();
                });
            }
            if (type == 'RES_APP') {
                var request = $.ajax({
                    url: '/rapi/rvp/resident-application/search-resident-applications?s=' + encodeURIComponent(searchValue) + '&f=' + filterValue + '&lpt=' + lastSearchProspectTimestamp + '&i=' + lastSearchInterval,
                    type: 'GET',
                    dataType: 'json'
                });
                request.done(function (msg) {
                    parseResidentApplications(msg);
                    if (paging) {

                    } else {
                        postEmailSearch(searchValue, clearButton, intro, noResults);
                    }
                    if (msg.length > 0) {
                        lastSearchProspectTimestamp = msg[msg.length - 1]['createdOnMillis'];
                        $('#moreSearchProspects').show();
                    }
                    if (paging && msg.length == 0) {
                        $('#moreSearchProspects').hide();
                        $('#noMoreSearchProspects').show();
                    }
                    if (!paging && msg.length < 20) {
                        $('#moreSearchProspects').hide();
                        if (msg.length > 0) {
                            $('#noMoreSearchProspects').show();
                        }
                    }
                    $('#moreSearchProspects').removeClass('loading');
                });
                request.fail(function (jqXHR, textStatus) {
                    if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                        alert(jqXHR.responseJSON.message);
                    } else {
                        alert('An error occurred, please contact your Client Success Manager for assistance.');
                    }
                });
            } else {
                var leadType = $('#filterLeadType').val();
                if (!leadType) {
                    leadType = '';
                }
                var callClassificationElement = document.getElementById('filterCallClassification');
                var callClassificationParam = !!callClassificationElement && !!callClassificationElement.value ? '&call-classification=' + callClassificationElement.value : '';
                var sourceIdElement = document.getElementById('filterSourceType');
                //if the filterSourceType is not found, we default to 0 so that the page will filter on All Sources.
                var sourceIdParam = !!sourceIdElement && !!sourceIdElement.value ? '&source-id=' + sourceIdElement.value : '&source-id=0';
                var request = $.ajax({
                    url: '/rapi/rvp/contact/search-user-prospects?s=' + encodeURIComponent(searchValue) + '&f=' + filterValue + '&t=' + type + '&lpt=' + lastSearchProspectTimestamp + '&i=' + lastSearchInterval + '&lt=' + leadType + callClassificationParam + sourceIdParam,
                    type: 'GET',
                    dataType: 'json'
                });
                request.done(function (msg) {
                    parseEmails(msg, type);
                    if (paging) {

                    } else {
                        postEmailSearch(searchValue, clearButton, intro, noResults);
                    }
                    if (msg.length > 0) {
                        lastSearchProspectTimestamp = msg[msg.length - 1]['createdOnMillis'];
                        $('#moreSearchProspects').show();
                    }
                    if (paging && msg.length == 0) {
                        $('#moreSearchProspects').hide();
                        $('#noMoreSearchProspects').show();
                    }
                    if (!paging && msg.length < 20) {
                        $('#moreSearchProspects').hide();
                        if (msg.length > 0) {
                            $('#noMoreSearchProspects').show();
                        }
                    }
                    $('#moreSearchProspects').removeClass('loading');
                    $('.tooltip').tooltip({
                        show: {delay: TOOLTIP_DELAY}
                    });
                });
                request.fail(function (jqXHR, textStatus) {
                    alert('An error occurred, please contact your Client Success Manager for assistance.');
                });
            }
        } else {
            clearEmailSearchDB(searchInput, clearButton, intro, content, noResults, type);
        }
    }
}

function clearEmailSearchDB(searchInput, clearButton, intro, content, noResults, type) {
    if ($('#noMoreProspects').length == 0 || $('#noMoreProspects').hasClass('loaded')) {
        $('#noMoreProspects').show();
        clearEmailSearch(searchInput, clearButton, intro, content, noResults);
    } else if ($.trim($('#filterBy').val()) != '' || $('#filterApplicationId').val() != '') {
        $(searchInput).val('');
        $(clearButton).hide();
        $(searchInput).focus();
        $(noResults).hide();
        $('.contact-content .contact-card').show();
        emailSearchDB(searchInput, clearButton, intro, content, noResults, type);
    } else {
        $(searchInput).val('');
        $(clearButton).hide();
        $(searchInput).focus();
        $(noResults).hide();
        $('.contact-content .contact-card').show();
        resetEmailSearchDB(intro, content);
        lastProspectTimestamp = new Date().getTime() + (new Date().getTimezoneOffset() * 60 * 1000);
        if (type == 'RES_APP') {
            loadResidentApplications(lastInterval, true);
        } else {
            loadEmails(lastInterval, type, true);
        }
    }
}

function resetEmailSearchDB(intro, content) {
    $(intro).each(function () {
        $(this).remove();
    });
    $(content).each(function () {
        $(this).remove();
    });
    $('#moreProspects').show();
    $('#noMoreProspects').hide();
    $('#noMoreProspects').removeClass('loaded');
    $('#moreSearchProspects').hide();
    $('#noMoreSearchProspects').hide();
}

function emailSearch(searchInput, clearButton, intro, content, noResults) {
    var searchValue = $.trim($(searchInput).val()).toLowerCase().replace('&', '&amp;');
    var filterValue = $.trim($('#filterBy').val()).toLowerCase().replace('&', '&amp;');
    if ($('#filterBy').length == 0 && $('#filterApplicationId').val() != '') {
        filterValue = $.trim($('#filterApplicationId option:selected').text()).toLowerCase().replace('&', '&amp;');
    }
    $(content).hide();
    var leadType = $('#filterLeadType').val();
    if (!leadType) {
        leadType = '';
    }
    $(intro).each(function () {
        if ($(this).html().toLowerCase().indexOf(searchValue) != -1 && $(this).html().toLowerCase().indexOf(filterValue) != -1 && (leadType == '' || $(this).hasClass(leadType))) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
    $(content).each(function () {
        if ($(this).html().toLowerCase().indexOf(searchValue) != -1 && $(this).html().toLowerCase().indexOf(filterValue) != -1 && (leadType == '' || $(this).hasClass(leadType))) {
            $('#emailIntro' + $(this).attr('id').substring('email'.length)).show();
        }
    });
    postEmailSearch(searchValue, clearButton, intro, noResults);
}

function postEmailSearch(searchValue, clearButton, intro, noResults) {
    if (searchValue.length > 0) {
        $(clearButton).show();
    }
    var first = $(intro + ':visible:first');
    if (first.length) {
        first.click();
        $(noResults).hide();
        $('.contact-content .contact-card').show();
    } else {
        $(noResults).show();
        $('.contact-content .contact-card').hide();
    }
    calculatedScrollTop = 0;
    $('.intro.selected').parent().animate({scrollTop: calculatedScrollTop}, 100);
}

function clearEmailSearch(searchInput, clearButton, intro, content, noResults) {
    $(searchInput).val('');
    $(intro).show();
    $(content).hide();
    $(clearButton).hide();
    $(searchInput).focus();
    $(noResults).hide();
    $('.contact-content .contact-card').show();
    if ($.trim($('#filterBy').val()) != '' || $('#filterApplicationId').val() != '') {
        emailSearch(searchInput, clearButton, intro, content, noResults);
    } else {
        postClearEmailSearch();
    }
}

function postClearEmailSearch() {
    $('.intro:visible:first').click();
    calculatedScrollTop = 0;
    $('.intro.selected').parent().animate({scrollTop: calculatedScrollTop}, 100);
}

function loadFilterBy(type) {
    $('#filterBy').autocomplete({
        source: function (request, response) {
            var ajaxRequest = $.ajax({
                url: '/rapi/rvp/user/search-user-applications?s=' + request.term,
                type: 'GET',
                dataType: 'json'
            });
            ajaxRequest.done(function (msg) {
                var results = new Array();
                for (var i = 0; i < msg.length; i++) {
                    var application = msg[i];
                    results.push({label: application['serverName'], value: application['applicationId']});
                }
                response(results);
            });
            ajaxRequest.fail(function (jqXHR, textStatus) {
                if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
                    alert(jqXHR.responseJSON.message);
                } else {
                    alert('An error occurred during your search. Please try again.');
                }
                response([]);
            });
        },
        focus: function (event, ui) {
            event.preventDefault();
            $('#filterBy').val(ui.item.label);
        },
        select: function (event, ui) {
            event.preventDefault();
            $('#filterBy').val(ui.item.label);
            $('#filterApplicationId').val(ui.item.value);
            $('#clearEmailFilter').show();
            document.filterApplication.submit();
        }
    });
}

function clearEmailFilterDB(filterClearButton, searchInput, clearButton, intro, content, noResults, type) {
    $('#filterBy').val('');
    $('#filterApplicationId').val('');
    $(filterClearButton).hide();
    $('#filterBy').focus();
    lastInterval = .25;
    emailSearchDB(searchInput, clearButton, intro, content, noResults, type);
}

function validateExportReport(startDateSelector, endDateSelector, months) {
    if (validateDateRange($(startDateSelector), $(endDateSelector))) {
        var startDateParts = $.trim($(startDateSelector).val()).split('/');
        var endDateParts = $.trim($(endDateSelector).val()).split('/');
        var startDateObj = new Date(startDateParts[2], startDateParts[0] - 1, startDateParts[1]);
        var endDateObj = new Date(endDateParts[2], endDateParts[0] - 1, endDateParts[1]);
        startDateObj.setDate(startDateObj.getDate() + 31 * months);
        if (startDateObj < endDateObj) {
            alert('Please limit date range to ' + months + ' months or less.');
            return false;
        }
        return true;
    }
    return false;
}

function validateCallReport() {
    return validateExportReport('#callStartDate', '#callEndDate', 3);
}

function validateEmailReport() {
    return validateExportReport('#emailStartDate', '#emailEndDate', 3);
}

function validateLeadReport() {
    return validateExportReport('#leadStartDate', '#leadEndDate', 3);
}

function validateLeaseReport() {
    return validateExportReport('#leaseStartDate', '#leaseEndDate', 12);
}

function checkPriceRange() {
    var didSucceed = true;
    $('tr:has(input)').each(function (i, row) {
        var $row = $(row),
            $low = $row.find('input.number:eq(0)'),
            $high = $row.find('input.number:eq(1)'),
            priceLow = parseInt($low.val()),
            priceHigh = parseInt($high.val());

        if (priceLow > priceHigh) {
            alert('Lower rent range must be less than or equal to the higher rent range.');
            $low.focus();
            didSucceed = false;
            return;
        }
    });
    return didSucceed;
}

function checkBathrooms(halfBath, threeQuarterBath, fullBath, totalBath) {
    var computedTotal = parseInt($(halfBath).val()) + parseInt($(threeQuarterBath).val()) + parseInt($(fullBath).val());
    var inputTotal = Math.ceil(parseFloat($(totalBath).val()));
    if (computedTotal > 0 && computedTotal != inputTotal) {
        alert('Total bathrooms (' + $(totalBath).val() + ') does not equal the number of partial bathrooms (' + computedTotal + '). Please check your inputs.');
        $(halfBath).focus();
        return false;
    }
    return true;
}

function toggleLeaseFloorplan(selectBox, floorplanWrapper, floorplanSelect) {
    if ($(selectBox + ' option:selected').hasClass('community')) {
        $(floorplanSelect).hide();
        $(floorplanSelect).empty();
        $(floorplanWrapper + ' img').show();
        $(floorplanWrapper).show();
        var request = $.ajax({
            url: '/rapi/rvp/community/get-community-floorplans?a=' + $(selectBox).val(),
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            $(floorplanSelect).addClass('required');
            var html = '<option value="">Choose Floorplan</option>';
            for (var i = 0; i < msg.length; i++) {
                var f = msg[i];
                html += '<option value="' + f['a'] + (msg.length == 1 ? '" selected="selected' : '') + '">' + f['b'] + '</option>';
            }
            html += '<option value="-1">Other</option>';
            $(floorplanSelect).html(html);
            $(floorplanSelect).show();
            $(floorplanWrapper + ' img').hide();
        });
        request.fail(function (jqXHR, textStatus) {
            if (jqXHR.responseJson && jqXHR.responseJson.message) {
                alert(jqXHR.responseJson.message);
            } else {
                alert('An error occurred, please contact your Client Success Manager for assistance.');
            }
        });
    } else {
        $(floorplanWrapper).hide();
        $(floorplanSelect).removeClass('required');
    }
}

function validateDateRange(startDateObj, endDateObj, required) {
    var startDate = $.trim(startDateObj.val());
    var endDate = $.trim(endDateObj.val());
    if (!required && (startDate.length == 0 && endDate.length == 0)) {
        return true;
    }
    if (required && startDate.length == 0) {
        alert('Please enter a start date.');
        startDateObj.focus();
        return false;
    }
    if (required && endDate.length == 0) {
        alert('Please enter an end date.');
        endDateObj.focus();
        return false;
    }
    var startDateParts = startDate.split('/');
    if (startDate.length > 0 && (startDateParts.length != 3 || startDateParts[0].length != 2 || startDateParts[1].length != 2 || startDateParts[2].length != 4)) {
        alert('Please use MM/DD/YYYY format for start date.');
        startDateObj.focus();
        return false;
    }
    var endDateParts = endDate.split('/');
    if (endDate.length > 0 && (endDateParts.length != 3 || endDateParts[0].length != 2 || endDateParts[1].length != 2 || endDateParts[2].length != 4)) {
        alert('Please use MM/DD/YYYY format for end date.');
        endDateObj.focus();
        return false;
    }
    var startDateObj = new Date(startDateParts[2], startDateParts[0] - 1, startDateParts[1]);
    if (startDate.length > 0 && (startDateObj.getMonth() + 1 != parseInt(startDateParts[0]) || startDateObj.getDate() != parseInt(startDateParts[1]) || startDateObj.getFullYear() != parseInt(startDateParts[2]))) {
        alert('Please use MM/DD/YYYY format for start date.');
        startDateObj.focus();
        return false;
    }
    var endDateObj = new Date(endDateParts[2], endDateParts[0] - 1, endDateParts[1]);
    if (endDate.length > 0 && (endDateObj.getMonth() + 1 != parseInt(endDateParts[0]) || endDateObj.getDate() != parseInt(endDateParts[1]) || endDateObj.getFullYear() != parseInt(endDateParts[2]))) {
        alert('Please use MM/DD/YYYY format for end date.');
        endDateObj.focus();
        return false;
    }
    if (startDate.length > 0 && endDate.length > 0 && endDateObj < startDateObj) {
        alert('Start date must be before end date.');
        startDateObj.focus();
        return false;
    }
    return true;
}

// Borrowed from https://github.com/burocratik/outdated-browser
var supports = (function () {
    var div = document.createElement('div');
    var vendors = 'Khtml Ms O Moz Webkit'.split(' ');
    var len = vendors.length;

    return function (prop) {
        if (prop in div.style) return true;

        prop = prop.replace(/^[a-z]/, function (val) {
            return val.toUpperCase();
        });

        while (len--) {
            if (vendors[len] + prop in div.style) {
                return true;
            }
        }
        return false;
    };
})();

function isIE() {
    // Simple check for IE per https://stackoverflow.com/a/21712356/1650282
    return window.document.documentMode;
}

function dismissAnnouncement(announcementId) {
    $('#announcement').slideUp();
    $.ajax({
        url: '/rapi/rvp/user/update-user-announcement?a=' + announcementId,
        type: 'PUT',
        dataType: 'text'
    });
}

function sendQuestion() {
    sendMAContactRequest('email');
}

function sendFloorplanSpecialRequest() {
    sendMAContactRequest('floorplanSpecial');
}

function sendMAContactRequest(prefix) {
    if ($.trim($('#' + prefix + 'Comments').val()).length == 0 || $.trim($('#' + prefix + 'ReplyType').val()).length == 0 || $.trim($('#' + prefix + 'ReplyInfo').val()).length == 0) {
        $('#' + prefix + 'MissingInput').show();
        return;
    }

    $('#' + prefix + 'MissingInput').hide();
    var json = new Object();
    json['a'] = $('#' + prefix + 'ApplicationId').val();
    json['ma'] = $('#' + prefix + 'MarketingAdvisorId').val();
    json['u'] = $('#' + prefix + 'UserId').val();
    json['c'] = $('#' + prefix + 'Comments').val();
    json['rt'] = $('#' + prefix + 'ReplyType').val();
    json['ri'] = $('#' + prefix + 'ReplyInfo').val();
    json['p'] = $('#' + prefix + 'PageName').val();
    json['pu'] = $('#' + prefix + 'PageUrl').val();
    if ($('#' + prefix + 'FloorplanName').length > 0) {
        json['f'] = $('#' + prefix + 'FloorplanName').val();
    }
    if ($('#specialType').length > 0) {
        json['st'] = $('#specialType').val();
    }
    json['t'] = prefix;
    $('#' + prefix + 'Loader').show();
    $('#' + prefix + 'ButtonText').css('opacity', '0.0');

    disable('#' + prefix + 'contactMAButton');

    var request = $.ajax({
        url: '/rapi/rvp/email/contact-marketing-advisor',
        type: 'POST',
        data: json,
    });
    request.done(function (msg) {
        $('#' + prefix + 'Loader').hide();
        $('#' + prefix + 'ButtonText').css('opacity', '1.0');
        enable('#' + prefix + 'contactMAButton');
        if (msg['m'] != null) {
            $('#' + prefix + 'Error').html(msg['m']);
            $('#' + prefix + 'Error').show();
        } else {
            $('#' + prefix + 'Error').hide();
            $('#' + prefix + 'ReplyType').val('Phone');
            $('#' + prefix + 'ReplyInfo').val($('#' + prefix + 'ReplyPhone').val());
            $('#' + prefix + 'Comments').val('');
            try {
                //Find the image tag and grab its source (returns a URL)
                let imageSource = document.querySelector('#email-popup .marketingAdvisorInfo img').src;
                let imageString = '<img class="image-icon" src="' + imageSource + '">';
                //Begin constructing the popup message (split into header and body for readability)
                let headerSection = '<div class="header-section"><h1>Thanks for submitting your request!</h1></div>';
                let bodySection = '<div class="body-section">Our support team will be in touch soon to update you when it’s completed or follow up with any questions we may have.</div>';
                let popupString = '<div class="submission-popup">' + imageString + headerSection + bodySection + '</div>';
                magnific(popupString);
            } catch (err) {
                console.error('An error occurred with populating the confirmation popup. The form was successfully submitted.');
                $.magnificPopup.close();
            }
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#' + prefix + 'Loader').hide();
        $('#' + prefix + 'ButtonText').css('opacity', '1.0');
        enable('#' + prefix + 'contactMAButton');
        $('#' + prefix + 'Error').html('We were unable to send the email, please try again.');
        $('#' + prefix + 'Error').show();
    });
}

/**
 * Load the special expiration popup on the Dashboard, Floorplan Details, Community Details and Floorplan Analytics pages.
 * @param {number} applicationId If editing a Community special, the community's applicationId.
 * @param {string} specialType Either 'community' or 'floorplan' based on which type of special is being viewed/edited in the popup.
 * @param {string} name Either the Community or Floorplan name.
 * @param {string} specialContentElementId The element id for the current special special content.
 * @param {string} specialTermsContentElementId The element id for the current special terms content.
 * @param {string} lastUpdatedDate The date the special was last updated.
 * @param {string} seeSpecialLabel The custom label for "See Special"
 * @param {number} floorplanId If editing a Floorplan special, the floorplan's floorplanId.
 * @param {string} existingSpecialExpirationElementId The element id for the hidden (display: none) element that has the current
 *            special expiration (gets updated if the special is modified asynchronously--so this is our single source of
 *            truth for the special expiration date).
 */
function loadFloorplanSpecial(applicationId, specialType, name, specialContentElementId, specialTermsContentElementId, lastUpdatedDate, seeSpecialLabel, floorplanId, existingSpecialExpirationElementId) {
    if (specialContentElementId !== null) {
        // I don't know of a good way to hook into the popup's "close" event, so perform this hideShow() here to ensure
        // the edit is hidden and the display is shown for the special expiration when the popup is opened. This is solving
        // the oddity of showing the edit field, not saving, closing the popup and then reopening it only to find the
        // edit field is still shown. Basically, we want to ensure the popup is in a "clean" state when it's opened.
        hideShow('#special-expiration-edit', '#special-expiration-display');

        var specialPopup = $('#floorplan-special-popup');
        specialPopup.addClass('has-existing-special');
        // The popup needs to know where the single source of truth is for the special expiration date, so give it the proper element id for this date.
        specialPopup.data('existingSpecialExpirationElementId', existingSpecialExpirationElementId);
        $('#current-floorplan-special').html($('#' + specialContentElementId).html());
        $('#current-floorplan-special-terms').html($('#' + specialTermsContentElementId).html());
        $('#current-floorplan-last-updated').text(lastUpdatedDate);
        // Pull the existing expiration date from the source of truth and use it for display in the popup.
        // Need to .trim(), because of how community specials are stored, there may be extra whitespace causing the === 'N/A' to fail below.
        var existingExpirationDate = $('#' + existingSpecialExpirationElementId).text().trim();
        $('#current-floorplan-expiration').text(existingExpirationDate);
        $('#current-see-special-label').text(seeSpecialLabel);
        // When there's no expiration date, it's nice to display N/A, but we don't want that for the actual datepicker input (it's not a valid date).
        $('#popup-special-date-picker').val(existingExpirationDate === 'N/A' ? '' : existingExpirationDate);
        $('.current-floorplan-header').html('Need to make a change <br/> to this ' + specialType.toLowerCase() + ' special?');
    } else {
        $('#floorplan-special-popup').removeClass('has-existing-special');
        $('.current-floorplan-header').html('Need to add a <br/> ' + specialType.toLowerCase() + ' special?');
    }

    $('.current-special-label .special-type').text(specialType);
    $('#floorplanSpecialApplicationId').val(applicationId);
    $('#floorplan-name-for-special').text(name);
    $('#floorplanSpecialFloorplanName').val(name);
    $('#popup-floorplan-id').val(!!floorplanId ? floorplanId : '');
    $('#specialType').val(specialType.toLowerCase());
}

function populateFloorplans(applicationId, selectBox, wrapper, selectedValue) {
    if (applicationId != '') {
        if ($(selectBox + ' option').length == 0 || selectedValue == null) {
            $(selectBox).hide();
            // Reset the selectBox to an initial option with no value
            // This helps maintain the space the selectbox takes up on the page while ensuring any existing options are wiped out
            $(selectBox).html('<option value="">Floorplan</option>');
            // using `.css` instead of `.show` to properly restore default display value for img tags
            $(wrapper + ' img').css('display', 'inline');
            $(wrapper).show();
            var request = $.ajax({
                url: '/rapi/rvp/community/get-community-floorplans?a=' + applicationId,
                type: 'GET',
                dataType: 'json'
            });
            request.done(function (msg) {
                if (msg.length > 0) {
                    $(selectBox).addClass('required');
                    var html = '<option value="">Floorplan</option>';
                    for (var i = 0; i < msg.length; i++) {
                        var f = msg[i];
                        html += '<option value="' + f['a'] + ((msg.length == 1 || (selectedValue != null && (f['a'] == selectedValue || f['b'] == selectedValue))) ? '" selected="selected' : '') + '">' + f['b'] + '</option>';
                    }
                    $(selectBox).html(html);
                    $(selectBox).show();
                    // using `.css` instead of `.show` to properly restore default display value for img tags
                    $(wrapper + ' img').css('display', 'none');
                } else if (selectedValue) {
                    var html = '<option value="">' + selectedValue + '</option>';
                    $(selectBox).html(html);
                    $(selectBox).show();
                    // using `.css` instead of `.show` to properly restore default display value for img tags
                    $(wrapper + ' img').css('display', 'none');
                } else {
                    $(selectBox).removeClass('required');
                    $(wrapper).hide();
                }
            });
            request.fail(function (jqXHR, textStatus) {
                if (jqXHR.responseJson && jqXHR.responseJson.message) {
                    alert(jqXHR.responseJson.message);
                } else {
                    alert('An error occurred, please contact your Client Success Manager for assistance.');
                }
            });
        } else {
            $(wrapper).show();
        }
    } else {
        $(wrapper).hide();
    }
}

function addTenantPhone() {
    var numPhones = $('.tenantPhone').length + 1;
    var phoneHtml = '<div class="tenantPhone input-wrapper offset-left"><select id="tenantPhone' + numPhones + 'Type"><option value="Cell">Cell</option><option value="Home">Home</option><option value="Work">Work</option>';
    phoneHtml += '<option value="Other">Other</option></select> <input type="text" id="tenantPhone' + numPhones + '" placeholder="123-456-7890" onkeypress="autoCorrectPhone(event, this);"/></div>';
    $('#addTenantPhone').before(phoneHtml);
    initSelect2();
}

function addTenantEmail() {
    var numEmails = $('.tenantEmail').length + 1;
    var emailHtml = '<div class="tenantEmail input-wrapper offset-left"><select id="tenantEmail' + numEmails + 'Type"><option value="Home">Home</option><option value="Work">Work</option>';
    emailHtml += '<option value="Other">Other</option></select> <input type="text" id="tenantEmail' + numEmails + '"/></div>';
    $('#addTenantEmail').before(emailHtml);
    initSelect2();
}

function addTenant(bypass) {
    var addSubmit = $('#addTenantSubmit');
    var oldSubmitLabel = addSubmit.val();
    disable(addSubmit);
    addSubmit.val('Validating...');
    var numTenants = $('.tenantRecord').length + 1;
    var firstName = $('#tenantFirstName').val();
    var lastName = $('#tenantLastName').val();
    var phone1 = $('#tenantPhone1').val();
    var email1 = $('#tenantEmail1').val();
    if ($.trim(firstName) == '' || $.trim(lastName) == '' || ($.trim(phone1) == '' && $.trim(email1) == '')) {
        $('#tenantMissingInput').show();
        enable(addSubmit);
        addSubmit.val(oldSubmitLabel);
        return false;
    }
    $('#tenantMissingInput').hide();
    var customer = new Object();
    customer['firstName'] = firstName;
    customer['lastName'] = lastName;
    var customerPhones = new Array();
    var customerEmails = new Array();
    var tenantHtml = '<div class="tenantRecord" id="tenantRecord' + numTenants + '"><p>' + firstName + ' ' + lastName + ' <a href="#" onclick="$(\'#tenantRecord' + numTenants + '\').remove();return false;"><img src="/assets/images/user/v2/remove.png" class=\'tooltip close-gray\' title=\'Remove Resident\' alt="Remove"/><img class=\'tooltip close-white\' src="/assets/images/user/rvp/CloseWhite.svg" class=\'tooltip\' title=\'Remove Resident\' alt="Remove"/></a></p>';
    var phones = $('.tenantPhone input');
    var phoneList = '';
    for (var i = 0; i < phones.length; i++) {
        var phoneNumber = $.trim($(phones[i]).val());
        if (isPhoneValid(phoneNumber)) {
            tenantHtml += '<input name="tenant' + numTenants + 'PhoneType' + (i + 1) + '" type="hidden" value="' + $('#tenantPhone' + (i + 1) + 'Type').val() + '"/><input name="tenant' + numTenants + 'Phone' + (i + 1) + '" type="hidden" value="' + phoneNumber + '"/>';
            phoneList += phoneNumber + ',';
            var nextPhone = new Object();
            nextPhone['type'] = 'PHONE';
            nextPhone['label'] = $('#tenantPhone' + (i + 1) + 'Type').val();
            nextPhone['value'] = phoneNumber;
            customerPhones.push(nextPhone);
        } else if (phoneNumber != '') {
            alert('Please enter phone number in format 123-456-7890.');
            $(phones[i]).focus();
            enable(addSubmit);
            addSubmit.val(oldSubmitLabel);
            return false;
        }
    }
    var emails = $('.tenantEmail input');
    var emailList = '';
    for (var i = 0; i < emails.length; i++) {
        var emailAddress = $.trim($(emails[i]).val());
        if (isEmailValid(emailAddress)) {
            tenantHtml += '<input name="tenant' + numTenants + 'EmailType' + (i + 1) + '" type="hidden" value="' + $('#tenantEmail' + (i + 1) + 'Type').val() + '"/><input name="tenant' + numTenants + 'Email' + (i + 1) + '" type="hidden" value="' + emailAddress + '"/>';
            emailList += emailAddress + ',';
            var nextEmail = new Object();
            nextEmail['type'] = 'EMAIL';
            nextEmail['label'] = $('#tenantEmail' + (i + 1) + 'Type').val();
            nextEmail['value'] = emailAddress;
            customerEmails.push(nextEmail);
        } else if (emailAddress != '') {
            alert('Please enter a valid email address.');
            $(emails[i]).focus();
            enable(addSubmit);
            addSubmit.val(oldSubmitLabel);
            return false;
        }
    }
    var request = $.ajax({
        url: '/rapi/rvp/customer/validate-new-customer?a=' + $('#leaseApplicationId').val() + '&d=' + $('#leaseApplicationDate').val() + '&p=' + phoneList + '&e=' + emailList + ($('#tenantCustomerId').length > 0 ? '&c=' + $('#tenantCustomerId').val() : ''),
        type: 'GET',
        dataType: 'json'
    });
    request.done(function (msg) {
        if (msg.length > 0 && !bypass) {
            $('#tenantErrorHolder').show();
            enable(addSubmit);
            addSubmit.val('Validate Again');
            $('#tenantErrorList').empty();
            for (var i = 0; i < msg.length; i++) {
                var leaseDate = new Date(msg[i]['d']);
                $('#tenantErrorList').append('<li>' + msg[i]['c'] + ' on ' + getMonth(leaseDate.getMonth()) + ' ' + leaseDate.getDate() + ', ' + leaseDate.getFullYear() + ' <a href="contact-leases?l=' + msg[i]['l'] + '" target="_blank"><img src="/assets/images/user/rvp/DotDotDot.svg" alt="See Lease" class=\'tooltip\' title=\'See Lease\'/></a></li>');
            }
            $('#tenantErrorList').find('.tooltip:not(.no-delay)').tooltip({
                show: {delay: TOOLTIP_DELAY}
            });
        } else {
            var leaseId = $('#tenantLeaseId').val();
            if (leaseId == null || leaseId.length == 0) {
                tenantHtml += '<input name="tenant' + numTenants + 'FirstName" type="hidden" value="' + firstName + '"/><input name="tenant' + numTenants + 'LastName" type="hidden" value="' + lastName + '"/></div>';
                $('#tenantList').append(tenantHtml);
                $('#tenantList').find('.tooltip').tooltip();
            } else {
                var customerId = $('#tenantCustomerId').val();
                if (customerId != null && customerId.length > 0) {
                    customer['customerId'] = customerId;
                }
                var contactInfo = new Object();
                contactInfo['PHONE'] = customerPhones;
                contactInfo['EMAIL'] = customerEmails;
                customer['contactInfo'] = contactInfo;
                updateCustomer(customer, $('#leaseApplicationId').val(), $('#leaseApplicationDate').val(), $('#tenantLeaseId').val());
            }
            $.magnificPopup.close();
            resetTenantForm(addSubmit);
        }
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message);
        } else {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        }
    });
}

function updateCustomer(customer, applicationId, leaseApplicationDate, leaseId) {
    var request = $.ajax({
        url: '/rapi/rvp/customer/update-customer?a=' + applicationId + '&ad=' + leaseApplicationDate + '&l=' + leaseId + '&c=' + JSON.stringify(customer),
        type: 'POST',
        dataType: 'json'
    });
    request.done(function (msg) {
        postLeaseUpdate(msg, leaseId, customer);
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJson && jqXHR.responseJson.message) {
            alert(jqXHR.responseJson.message);
        } else {
            alert('An error occurred, please contact your Client Success Manager for assistance.');
        }
    });
}

function postLeaseUpdate(msg, leaseId, customer) {
    var source = msg['source'];
    $('#leaseSource' + leaseId).remove();
    if (source != null) {
        var sourceHTML = '<span' + (source.indexOf('RentVision') > -1 ? ' style="color:#1e988a;"' : '') + '>' + source + '</span>';
        $('#firstContactSource' + leaseId).html('<strong>Source:</strong> ' + sourceHTML);
        $('#firstContactDate' + leaseId).html('<strong>Date:</strong> ' + msg['firstContact']);
        $('#emailIntro' + leaseId).append('<p class="message" id="leaseSource' + leaseId + '">Source: ' + sourceHTML + '</p>');
    } else {
        $('#firstContactSource' + leaseId).html('<strong>Source:</strong> Processing');
        $('#firstContactDate' + leaseId).html('<strong>Date:</strong> Processing');
    }
    if (customer != null) {
        if ($('#customer' + customer['customerId']).length > 0) {
            $('#customer' + customer['customerId']).html(buildCustomerData(customer, leaseId));
        } else {
            customer['customerId'] = msg['customerId'];
            var tmpArray = leasors[leaseId + ''];
            var html = '<div id="customer' + customer['customerId'] + '">';
            html += buildCustomerData(customer, leaseId);
            html += '</div>';
            tmpArray.push(customer['customerId']);
            $('#coleasors' + leaseId).append(html);
            leasors[leaseId + ''] = tmpArray;
        }
    }
    loadLeaseContacts(leaseId);
}

function resetTenantForm(addSubmit) {
    $('#tenantErrorHolder').hide();
    $('#tenantErrorList').empty();
    enable(addSubmit);
    addSubmit.val('Add');
    $('#tenant-popup h3').text('Add a Resident');
    $('#tenantFirstName').val('');
    $('#tenantLastName').val('');
    $('#tenantPhone1').val('');
    $('#tenantPhone1Type').val('Cell');
    $('#tenantEmail1').val('');
    $('#tenantEmail1Type').val('Home');
    var phoneWrappers = $('.tenantPhone');
    for (var i = 1; i < phoneWrappers.length; i++) {
        $(phoneWrappers[i]).remove();
    }
    var emailWrappers = $('.tenantEmail');
    for (var i = 1; i < emailWrappers.length; i++) {
        $(emailWrappers[i]).remove();
    }
    $('#tenantLeaseId').val('');
    $('#tenantCustomerId').val('');
}

function isPhoneValid(phoneNumber) {
    var validPhone = false;
    if (phoneNumber.length == 12) {
        var phoneParts = phoneNumber.split('-');
        var phoneString = phoneParts[0] + '' + phoneParts[1] + '' + phoneParts[2];
        if (phoneParts.length == 3 && phoneParts[0].length == 3 && phoneParts[1].length == 3 && phoneParts[2].length == 4 && parseInt(phoneString).toString() == phoneString) {
            validPhone = true;
        }
    }
    return validPhone;
}

function isEmailValid(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function sendNewSource() {
    if ($.trim($('#newSourceType').val()).length == 0 || $.trim($('#newSource').val()).length == 0) {
        $('#emailMissingInput').show();
        return;
    }
    $('#emailMissingInput').hide();
    var json = new Object();
    json['a'] = $('#emailApplicationId').val();
    json['u'] = $('#emailUserId').val();
    json['st'] = $('#newSourceType').val();
    json['s'] = $('#newSource').val();
    $('#emailLoader').show();
    $('#sendNewSourceButtonText').css('opacity', '0.0');
    disable('#newSourceContactMAButton');
    var request = $.ajax({
        url: '/rapi/rvp/email/send-new-source',
        type: 'POST',
        data: json,
    });
    request.done(function (msg) {
        $('#emailLoader').hide();
        $('#sendNewSourceButtonText').css('opacity', '1.0');
        enable('#newSourceContactMAButton');
        if (msg['m'] != null) {
            $('#emailError').html(msg['m']);
            $('#emailError').show();
        } else {
            $('#emailError').hide();
            $('#emailReplyType').val('');
            $('#emailComments').val('');
            try {
                //Begin constructing the popup (header and body split for readability)
                let headerSection = '<div class="header-section"><h1>Thanks for submitting your request!</h1></div>';
                let bodySection = '<div class="body-section">We will be in touch soon to update you when it’s completed or follow up with any questions we may have.</div>';
                let popupString = '<div class="submission-popup">' + headerSection + bodySection + '</div>';
                magnific(popupString);

            } catch (err) {
                console.error('An error occurred with populating the confirmation popup. The form was successfully submitted.');
                $.magnificPopup.close();
            }
        }
    });
    request.fail(function (jqXHR, textStatus) {
        $('#emailLoader').hide();
        $('#sendNewSourceButtonText').css('opacity', '1.0');
        enable('#newSourceContactMAButton');
        $('#emailError').html('We were unable to send the email, please try again.');
        $('#emailError').show();
    });
}

/**
 * Loops over all elements in the form with the 'required' class and ensures they all have values.
 * @param form {!string} jQuery selector string (such as '#someElementId') to select the form element.
 * @returns {boolean} `true` if all required elements have values; `false` otherwise.
 */
function checkRequiredElements(form) {
    var requiredElements = $(form).find('.required');
    for (var i = 0; i < requiredElements.length; i++) {
        if ($.trim($(requiredElements[i]).val()) == '') {
            alert('Please enter all required fields.');
            $(requiredElements[i]).focus();
            return false;
        }
    }
    return true;
}

/**
 * Loops over all elements in the form with the 'number' class and ensures they are whole numbers (unless empty).
 * @param form {!string} jQuery selector string (such as '#someElementId') to select the form element.
 * @returns {boolean} `true` if all non-empty elements are whole numbers; `false` otherwise.
 */
function checkNumberElements(form) {
    var numberElements = $(form).find('.number');
    for (var i = 0; i < numberElements.length; i++) {
        if ($(numberElements[i]).val() != '' && parseInt($(numberElements[i]).val()).toString() != $(numberElements[i]).val().toString()) {
            alert('This field requires a whole number.');
            $(numberElements[i]).focus();
            return false;
        }
    }
    return true;
}

/**
 * Performs form validation by checking all required elements and any number elements. Processes
 * any additional functions and disables the given input if form is valid.
 * NOTE: if an additional function returns false, no subsequent functions will be evaluated, this
 * function will be effectively short-circuited by returning `false` immediately.
 * @param form {!string} jQuery selector string (such as '#someElementId') to select the form element.
 * @param input {!string} jQuery selector string (such as '#someElementId') for the input (submit button, typically)
 * to disable if the form is valid (to prevent subsequent submission with no further changes).
 * @param additionalFunctions {?Function[]} An optional array of functions for further form validation.
 * @returns {boolean} `true` if all non-empty elements are whole numbers; `false` otherwise.
 */
function checkRequiredAndNumberForm(form, input, additionalFunctions) {
    if (checkRequiredElements(form) === false) return false;
    if (checkNumberElements(form) === false) return false;
    if (!!additionalFunctions && additionalFunctions.length) {
        for (var i = 0; i < additionalFunctions.length; i++) {
            if (!!additionalFunctions[i] && additionalFunctions[i]() === false) return false;
        }
    }
    disable(input); // Disable input to prevent accidental form resubmission.
    return true;
}

function checkFloorplanRentPrice() {
    if ($('#rentPriceLow').length && $('#rentPriceHigh').length) {
        var highRent = parseInt($('#rentPriceHigh').val());
        var lowRent = parseInt($('#rentPriceLow').val());

        if (lowRent < 0) {
            alert('Lower rent range must be a positive value.');
            $('#rentPriceLow').focus();
            return false;
        }
        if (highRent < lowRent) {
            alert('Higher rent range must be higher than lower rent range.');
            $('#rentPriceHigh').focus();
            return false;
        }
    }
    return true;
}

function checkTemporaryPrice() {
    if ($('#temporaryPriceMin').length && $('#temporaryPriceMax').length) {
        var temporaryPriceMin = parseInt($('#temporaryPriceMin').val());
        var temporaryPriceMax = parseInt($('#temporaryPriceMax').val());

        if (temporaryPriceMin < 0) {
            alert('Temporary price minimum must be a positive value.');
            $('#temporaryPriceMin').focus();
            return false;
        }
        if (temporaryPriceMax < temporaryPriceMin) {
            alert('Temporary price maximum must be higher than temporary price minimum.');
            $('#temporaryPriceMax').focus();
            return false;
        }
    }
    return true;
}

function checkFloorplanSqft() {
    if ($('#sqft').length && $('#sqftMax').length && $('#sqftMax').val().length > 0) {
        var highSqft = parseInt($('#sqftMax').val());
        var lowSqft = parseInt($('#sqft').val());

        if (isNaN(lowSqft) || lowSqft <= 0) {
            alert('Lower sq ft must be a number greater than 0.');
            $('#sqft').focus();
            return false;
        }
        if (highSqft < lowSqft) {
            alert('Higher sq ft must be higher than lower sq ft.');
            $('#sqftMax').focus();
            return false;
        }
    }
    return true;
}

function checkFloorplanLeaseLength() {
    if ($('#leaseLengthMonthMin').length && $('#leaseLengthMonthMax').length) {
        var minValue = parseInt($('#leaseLengthMonthMin').val());
        var maxValue = parseInt($('#leaseLengthMonthMax').val());
        if (maxValue != 0 && maxValue < minValue) {
            alert('Lease length maximum must be longer than or equal to the lease length minimum.');
            $('#leaseLengthMonthMax').focus();
            return false;
        }
    }
    return true;
}

// This function should eventually be phased out in favor of more specific functions (checkForm() is very generic).
// Already verified stripped out of communityDetails.jsp and floorplanDetails.jsp.
function checkForm(form, input, additionalFunction, additionalFunctionTwo) {
    return checkRequiredAndNumberForm(form, input, [
        checkFloorplanRentPrice,
        checkFloorplanSqft,
        checkFloorplanLeaseLength,
        additionalFunction,
        additionalFunctionTwo,
    ]);
}

/**
 * Handle form input changes by setting the flag that indicates a change has been made and enables form submission (input).
 * @param submitInputSelector {string} JavaScript selector string (such as '#someElementId') for the input (submit button, typically) to enable
 */
function handleFormChange(submitInputSelector) {
    // Track that there has been a change to the form in rvpPageState.
    setHasFormChangeState();
    // Enable the submit input (so the form can actually be submitted).
    enable(submitInputSelector);
}

/**
 * Update rvpPageState.hasFormChange to true when a change occurs for a form input.
 */
function setHasFormChangeState() {
    rvpPageState.hasFormChange = true;
}

/**
 * Reset rvpPageState.hasFormChange back to false (when a form is submitted, for example).
 */
function resetHasFormChangeState() {
    rvpPageState.hasFormChange = false;
}

function validateLeaseForm(form, input) {
    if (checkForm(form, input)) {
        if (!validateDate($('#leaseApplicationDate'), true)) {
            enable(input);
            return false;
        }
        if (!validateDate($('#moveInDate'), false)) {
            enable(input);
            return false;
        }
        if ($('.tenantRecord').length == 0) {
            alert('Please enter one or more resident records.');
            enable(input);
            return false;
        }
        $('#leaseTenantCount').val($('.tenantRecord').length);
        return true;
    }
    return false;
}

function validateDate(dateObj, required) {
    var date = $.trim(dateObj.val());
    if (!required && date.length == 0) {
        return true;
    }
    if (required && date.length == 0) {
        alert('Please enter a start date.');
        dateObj.focus();
        return false;
    }
    var dateParts = date.split('/');
    if (date.length > 0 && (dateParts.length != 3 || dateParts[0].length != 2 || dateParts[1].length != 2 || dateParts[2].length != 4)) {
        alert('Please use MM/DD/YYYY format for start date.');
        dateObj.focus();
        return false;
    }
    var datePartsObj = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]);
    if (date.length > 0 && (datePartsObj.getMonth() + 1 != parseInt(dateParts[0]) || datePartsObj.getDate() != parseInt(dateParts[1]) || datePartsObj.getFullYear() != parseInt(dateParts[2]))) {
        alert('Please use MM/DD/YYYY format for start date.');
        dateObj.focus();
        return false;
    }
    return true;
}

function googleChartErrorHandler(e) {
    $('#google-visualization-errors-0 span').css({'background-color': '#d6433c', 'padding': '.25em .5em'});
    $('#google-visualization-errors-0 span span').css({
        'margin-left': '1em',
        'padding': '0',
        'vertical-align': 'inherit'
    });
}

function floorplanTableSorter(node) {
    if (node.childNodes.length > 1) {
        for (var i = 0; i < node.childNodes.length; i++) {
            var nodeName = node.childNodes[i].nodeName;
            if (nodeName == 'SELECT' || nodeName == 'INPUT') {
                return $(node.childNodes[i]).val();
            }
        }
    }
    return node.innerHTML;
}

function saveLeaseInfo(prefix, lease, type) {
    var newValue = $.trim($('#' + prefix + 'Input' + lease).val());
    if (newValue == null || newValue.length == 0) {
        alert('Please enter a new value before saving.');
        return false;
    }
    var request = $.ajax({
        url: '/rapi/rvp/lease/update-lease-info?l=' + lease + '&t=' + type + '&v=' + newValue,
        type: 'PUT',
        dataType: 'text'
    });
    request.done(function (msg) {
        if (type == 'AD' || type == 'MD') {
            var newDate = new Date(newValue);
            $('#' + prefix + 'Label' + lease).text(getMonth(newDate.getMonth()) + ' ' + newDate.getDate() + ', ' + newDate.getFullYear());
            if (type == 'AD') {
                var today = new Date();
                $('#leaseDate' + lease).text(getMonth(newDate.getMonth()) + ' ' + newDate.getDate() + (today.getFullYear() != newDate.getFullYear() ? ', ' + newDate.getFullYear() : ''));
                postLeaseUpdate(msg, lease);
            }
        } else if (type == 'MR') {
            $('#' + prefix + 'Label' + lease).text('$' + newValue);
        } else if (type == 'FP') {
            var newFloorplanTitle = $('#' + prefix + 'Input' + lease).find(':selected').text();
            $('#' + prefix + 'Label' + lease).text(newFloorplanTitle);
            $('#leaseFloorplanTitle' + lease).text(newFloorplanTitle);
        } else {
            $('#' + prefix + 'Label' + lease).text(newValue);
        }
        $('#' + prefix + 'LabelWrapper' + lease).show();
        $('#' + prefix + 'InputWrapper' + lease).hide();
    });
    request.fail(function (jqXHR, textStatus) {
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) {
            alert(jqXHR.responseJSON.message);
        } else {
            alert('Update failed. Please double check the value you entered and try again.');
        }
    });
}

function loadCustomer(applicationId, leaseId, customerId) {
    resetTenantForm($('#addTenantSubmit'));
    $('#residentWarning').show();
    $('#leaseApplicationId').val(applicationId);
    $('#leaseApplicationDate').val($('#applicationDateInput' + leaseId).val());
    $('#tenantLeaseId').val(leaseId);
    if (customerId != null) {
        $('#tenant-popup h3').text('Update Resident');
        $('#addTenantSubmit').val('Update');
        $('#tenantCustomerId').val(customerId);
        var request = $.ajax({
            url: '/rapi/rvp/customer/get-customer?c=' + customerId + '&a=' + applicationId,
            type: 'GET',
            dataType: 'json'
        });
        request.done(function (msg) {
            $('#tenantFirstName').val(msg['firstName']);
            $('#tenantLastName').val(msg['lastName']);
            var phones = msg['contactInfo']['PHONE'];
            if (phones != null) {
                var phoneNumber = phones[0]['value'];
                $('#tenantPhone1').val(phoneNumber.substring(1, 4) + '-' + phoneNumber.substring(6, 14));
                $('#tenantPhone1Type').val(phones[0]['label']);
                for (var i = 1; i < phones.length; i++) {
                    addTenantPhone();
                    phoneNumber = phones[i]['value'];
                    $('#tenantPhone' + (i + 1)).val(phoneNumber.substring(1, 4) + '-' + phoneNumber.substring(6, 14));
                    $('#tenantPhone' + (i + 1) + 'Type').val(phones[i]['label']);
                }
            }
            var emails = msg['contactInfo']['EMAIL'];
            if (emails != null) {
                $('#tenantEmail1').val(emails[0]['value']);
                $('#tenantEmail1Type').val(emails[0]['label']);
                for (var i = 1; i < emails.length; i++) {
                    addTenantEmail();
                    $('#tenantEmail' + (i + 1)).val(emails[i]['value']);
                    $('#tenantEmail' + (i + 1) + 'Type').val(emails[i]['label']);
                }
            }
        });
        request.fail(function (jqXHR, textStatus) {
            if (jqXHR.responseJson && jqXHR.responseJson.message) {
                alert(jqXHR.responseJson.message);
            } else {
                alert('Unable to fetch customer information. Please try again.');
            }
        });
    }
    $.magnificPopup.open({
        items: {
            src: '#tenant-popup',
            type: 'inline'
        }
    });
}

function autoCorrectPhone(event, phoneField) {
    if (event.charCode > 0) {
        var phoneCharacters = (phoneField.value + String.fromCharCode(event.charCode)).split('');
        var newPhoneValue = '';
        for (var i = 0; i < phoneCharacters.length; i++) {
            if (i == 3 && !(phoneCharacters.length == 4 && phoneCharacters[i] == '-')) {
                newPhoneValue += '-';
            } else if (i == 7 && !(phoneCharacters.length == 8 && phoneCharacters[i] == '-')) {
                newPhoneValue += '-';
            }
            if ($.isNumeric(phoneCharacters[i]) && i != (phoneCharacters.length - 1)) {
                newPhoneValue += phoneCharacters[i];
            }
        }
        phoneField.value = newPhoneValue;
    }
}

function adjustOverlay(graphID) {
    var overlay = null;
    var target = document.querySelector(graphID);
    var observer = new MutationObserver(function (mutations) {
        mutation = mutations[0];
        if ($(mutation.target).not('.ourOverlay').is('.google-visualization-tooltip:visible')) {
            $(graphID + ' .ourOverlay').remove();
            overlay = $(mutation.target).clone();
            overlay.addClass('ourOverlay');
            $(mutation.target).hide();
            $(graphID + '>div>div:first').append(overlay);
            $(overlay).on('mouseover', function () {
                var adjustLeft = 1;
                var adjustTop = 1;
                window.innerWidth / 2 > $(this).offset().left ? adjustLeft = 1 : adjustLeft = -1;
                window.innerHeight / 2 > $(this).offset().top ? adjustTop = 1 : adjustTop = -2;
                $(this).offset({
                    top: $(this).offset().top + adjustTop * $(this).height() / 2,
                    left: $(this).offset().left + adjustLeft * $(this).width() / 2
                });
            });
        }
    });
    var config = {attributes: true, subtree: true};
    observer.observe(target, config);
}

function validateCodedHours() {
    if ($('#useCustomHours').is(':checked')) {
        $('#hoursCoded').val('');
    } else {
        var hours = '';
        var friendlyHours = '';
        var tempFriendlyHours = '';
        var consecutiveCount = 0;
        var lastOpening = '';
        var lastClosing = '';
        for (var i = 0; i < 7; i++) {
            var opening = $('#opening_' + i).val();
            var closing = $('#closing_' + i).val();
            if ((opening != null && opening.length > 0 && closing != null && closing.length > 0) ||
                ((opening == null || opening.length == 0) && (closing == null || closing.length == 0))) {
                var friendlyOpening = '';
                var friendlyClosing = '';
                if (opening != null && opening.length > 0 && closing != null && closing.length > 0) {
                    if (!isValidTime(opening)) {
                        alert('Please input opening time in format h:mm.');
                        $('#opening_' + i).focus();
                        return false;
                    }
                    if (!isValidTime(closing)) {
                        alert('Please input closing time in format h:mm.');
                        $('#closing_' + i).focus();
                        return false;
                    }
                    var openingHour = parseInt(opening.split(':')[0]);
                    if (openingHour == 12) {
                        openingHour = 0;
                    }
                    if ($('#opening_z_' + i).val() == 2) {
                        openingHour += 12;
                    }
                    var closingHour = parseInt(closing.split(':')[0]);
                    if (closingHour == 12) {
                        closingHour = 0;
                    }
                    if ($('#closing_z_' + i).val() == 2) {
                        closingHour += 12;
                    }
                    friendlyOpening = opening + ($('#opening_z_' + i).val() == 1 ? 'am' : 'pm');
                    friendlyClosing = closing + ($('#closing_z_' + i).val() == 1 ? 'am' : 'pm');
                    hours += i + '-' + openingHour + ':' + opening.split(':')[1] + '-' + closingHour + ':' + closing.split(':')[1] + ';';
                } else {
                    friendlyOpening = 'Closed';
                    friendlyClosing = 'Closed';
                    hours += i + '--;';
                }
                if (lastOpening == '') {
                    lastOpening = friendlyOpening;
                }
                if (lastClosing == '') {
                    lastClosing = friendlyClosing;
                }
                if (lastOpening == friendlyOpening && lastClosing == friendlyClosing) {
                    consecutiveCount++;
                } else if (consecutiveCount > 2) {
                    if (lastOpening == 'Closed') {
                        friendlyHours += '<p>' + getDayOfWeek(i - consecutiveCount) + ' - ' + getDayOfWeek(i - 1) + ' Closed</p>';
                    } else {
                        friendlyHours += '<p>' + getDayOfWeek(i - consecutiveCount) + ' - ' + getDayOfWeek(i - 1) + ' ' + lastOpening + ' - ' + lastClosing + '</p>';
                    }
                    lastOpening = friendlyOpening;
                    lastClosing = friendlyClosing;
                    tempFriendlyHours = '';
                    consecutiveCount = 1;
                } else {
                    friendlyHours += tempFriendlyHours;
                    lastOpening = friendlyOpening;
                    lastClosing = friendlyClosing;
                    tempFriendlyHours = '';
                    consecutiveCount = 1;
                }
                if (friendlyOpening == 'Closed') {
                    tempFriendlyHours += '<p>' + getDayOfWeek(i) + ' Closed</p>';
                } else {
                    tempFriendlyHours += '<p>' + getDayOfWeek(i) + ' ' + friendlyOpening + ' - ' + friendlyClosing + '</p>';
                }
            } else if ((opening != null && opening.length > 0) || (closing != null && closing.length > 0)) {
                alert('Please input both an opening and closing time.');
                $('#opening_' + i).focus();
                return false;
            }
        }
        if (consecutiveCount > 2) {
            if (lastOpening == 'Closed') {
                friendlyHours += '<p>' + getDayOfWeek(i - consecutiveCount) + ' - ' + getDayOfWeek(i - 1) + ' Closed</p>';
            } else {
                friendlyHours += '<p>' + getDayOfWeek(i - consecutiveCount) + ' - ' + getDayOfWeek(i - 1) + ' ' + lastOpening + ' - ' + lastClosing + '</p>';
            }
        } else {
            friendlyHours += tempFriendlyHours;
        }
        $('#hoursCoded').val(hours);
        tinymce.get('hours').setContent(friendlyHours);
        $('#hours').val(friendlyHours);
    }
    return true;
}

function getDayOfWeek(day) {
    switch (day) {
        case 0 :
            return 'Monday';
        case 1 :
            return 'Tuesday';
        case 2 :
            return 'Wednesday';
        case 3 :
            return 'Thursday';
        case 4 :
            return 'Friday';
        case 5 :
            return 'Saturday';
        case 6 :
            return 'Sunday';
    }
}

function isValidTime(time) {
    if (time.indexOf(':') < 1 || time.indexOf(':') > 3) {
        return false;
    }
    var timeParts = time.split(':');
    if (timeParts[0] < 1 || timeParts[0] > 12) {
        return false;
    }
    if (timeParts[1] < 0 || timeParts[1] > 59) {
        return false;
    }
    return true;
}

function parseCodedHours() {
    var codedHours = $('#hoursCoded').val();
    if (codedHours != null && codedHours.length > 0) {
        var days = codedHours.split(';');
        for (var i = 0; i < days.length; i++) {
            var hourParts = days[i].split('-');
            if (hourParts[1] != null && hourParts[1].length > 0 && hourParts[2] != null && hourParts[2].length > 0) {
                var opens = hourParts[1];
                var opensHours = opens.split(':');
                var sanitizedOpens = parseInt(opensHours[0]) % 12;
                if (sanitizedOpens == 0) {
                    sanitizedOpens = 12;
                }
                $('#opening_' + hourParts[0]).val(sanitizedOpens + ':' + opensHours[1]);
                $('#opening_z_' + hourParts[0]).val(parseInt(opensHours[0]) > 11 ? 2 : 1);
                var closes = hourParts[2];
                var closesHours = closes.split(':');
                var sanitizedCloses = parseInt(closesHours[0]) % 12;
                if (sanitizedCloses == 0) {
                    sanitizedCloses = 12;
                }
                $('#closing_' + hourParts[0]).val(sanitizedCloses + ':' + closesHours[1]);
                $('#closing_z_' + hourParts[0]).val(parseInt(closesHours[0]) > 11 ? 2 : 1);
            }
        }
    }
}

function resetCodedHours() {
    for (var i = 0; i < 7; i++) {
        $('#opening_' + i).val('');
        $('#closing_' + i).val('');
    }
}

function setupAvailabilityQuestion($availabilitySection) {
    var $availabilitySelect = $availabilitySection.find('.availabilitySelect'),
        $availabilityDate = $availabilitySection.find('.availabilityDate'),
        $customAvailability = $availabilitySection.find('.customAvailability'),
        updateTriggerTarget = $availabilitySelect.data('trigger-target'),
        select2Inited = false,
        AVAILABILITIES = [
            {
                display: 'Available',
                name: 'AVAILABLE',
                type: 'AVAILABLE'
            },
            {
                display: 'Available on (date)',
                name: 'AVAILABLE_ON_DATE',
                type: 'AVAILABLE'
            },
            {
                display: 'Call for Details!',
                name: 'CALL_FOR_DETAILS',
                type: 'AVAILABLE'
            },
            {
                display: 'Limited Availability',
                name: 'LIMITED_AVAILABILITY',
                type: 'AVAILABLE'
            },
            {
                display: 'Sign Waitlist',
                name: 'WAITLIST',
                type: 'WAITLIST'
            },
            {
                display: 'Not Available',
                name: 'NOT_AVAILABLE',
                type: 'NOT_AVAILABLE'
            }
        ],
        MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        CALL_FOR_DETAILS_VALUE = 'Call for Details!',
        LIMITED_AVAILABILITY_VALUE = 'Limited Availability',
        DATE_REGEX = /^(\d{2}|\d{1})\/(\d{2}|\d{1})\/\d{4}$/;

    function getMonthFromNumber(monthNumber) {
        return MONTHS[monthNumber];
    }

    function addAvailability($select, availability, selected) {
        var $availability = $('<option data-availability-name="' + availability.name + '" value="' + availability.type + '" ' + (selected ? 'selected' : '') + ' >' + availability.display + '</option>');
        $select.append($availability);
    }

    function showDateSelector() {
        $availabilityDate.removeClass('hidden');
        if (!!$availabilityDate.val()) {
            setAvailableOnDateLabel($customAvailability, $availabilityDate.val());
        }
    }

    function hideDateSelector() {
        $availabilityDate.addClass('hidden');
        $availabilityDate.val('');
    }

    function getDateParts(dateStr) {
        var dateArr = dateStr.split('/');

        return {
            month: dateArr[0],
            day: dateArr[1],
            year: dateArr[2]
        };
    }

    if (!String.prototype.startsWith) {
        String.prototype.startsWith = function (searchString, position) {
            position = position || 0;
            return this.indexOf(searchString, position) === position;
        };
    }

    function setAvailableOnDateLabel($customAvailability, date) {
        //Date's format is dd/mm/yyyy or d/m/yyyy
        var dateParts = getDateParts(date);
        if ((dateParts.day.startsWith('0'))) {
            dateParts.day = dateParts.day.substr(1, 1);
        }

        $customAvailability.val('Available on ' + getMonthFromNumber(dateParts.month - 1) + ' ' + dateParts.day + ', ' + dateParts.year);
    }

    function setCallForDetailsLabel($customAvailability) {
        $customAvailability.val(CALL_FOR_DETAILS_VALUE);
    }

    function setLimitedAvailabilityLabel($customAvailability) {
        $customAvailability.val(LIMITED_AVAILABILITY_VALUE);
    }

    function handleAvailabilityChange($availability, $customAvailability, $availabilityDate, triggerTarget) {
        var availabilityName = $availability.data('availability-name');
        removeDateErrorMessage($availabilityDate);

        switch (availabilityName) {
            case 'AVAILABLE_ON_DATE':
                $customAvailability.val('');
                showDateSelector();
                disable(triggerTarget);
                break;

            case 'CALL_FOR_DETAILS':
                hideDateSelector();
                setCallForDetailsLabel($customAvailability);
                break;

            case 'LIMITED_AVAILABILITY':
                hideDateSelector();
                setLimitedAvailabilityLabel($customAvailability);
                break;

            default:
                hideDateSelector();
                $customAvailability.val('');
                break;
        }
    }

    function getSelectedAvailability($availability, $customAvailability, $availabilityDate) {
        if (!!$availabilityDate.val()) {
            showDateSelector();
            return 'AVAILABLE_ON_DATE';
        } else if ($customAvailability.val() === CALL_FOR_DETAILS_VALUE) {
            return 'CALL_FOR_DETAILS';
        } else if ($customAvailability.val() === LIMITED_AVAILABILITY_VALUE) {
            return 'LIMITED_AVAILABILITY';
        } else {
            return $availability.data('value');
        }
    }

    function showDateErrorMessage($availabilityDate, errorType) {
        if (errorType === 0) {
            $availabilityDate.after('<div class="availabilityDateError failure">Please use the following format: mm/dd/yyyy</div>');
        } else if (errorType === 1) {
            $availabilityDate.after('<div class="availabilityDateError failure">Please use a date that\'s in the future</div>');
        }
    }

    function removeDateErrorMessage($availabilityDate) {
        $availabilityDate.siblings('.availabilityDateError').remove();
    }

    function isDateValid(dateValue) {
        return DATE_REGEX.test(dateValue);
    }

    function isDateInTheFuture(dateValue) {
        var dateParts = getDateParts(dateValue),
            month = dateParts.month,
            day = dateParts.day,
            now = new Date();

        //Because we are nice and allow for single digit days/months we need to add 0s in front for proper parsing.
        if (month.length === 1) {
            month = '0' + month;
        }

        if (day.length === 1) {
            day = '0' + day;
        }

        return now < new Date(dateParts.year + '-' + month + '-' + day + 'T00:00:00Z');
    }

    //Init
    var selectedAvailability = getSelectedAvailability($availabilitySelect, $customAvailability, $availabilityDate);
    for (var idk in AVAILABILITIES) {
        var availability = AVAILABILITIES[idk];
        addAvailability($availabilitySelect, availability, availability.name === selectedAvailability);
    }

    $availabilitySelect.on('change', function () {
        if (select2Inited) {
            enable(updateTriggerTarget);
        } else {
            select2Inited = true;
        }

        handleAvailabilityChange($availabilitySelect.find('option:selected'), $customAvailability, $availabilityDate, updateTriggerTarget);
    }).change();

    $availabilityDate.on('change', function () {
        var dateVal = $availabilityDate.val();
        removeDateErrorMessage($availabilityDate);

        if (!!dateVal) {
            if (!isDateValid(dateVal)) {
                showDateErrorMessage($availabilityDate, 0);
                disable(updateTriggerTarget);
            } else if (!isDateInTheFuture(dateVal)) {
                showDateErrorMessage($availabilityDate, 1);
                disable(updateTriggerTarget);
            } else {
                setAvailableOnDateLabel($customAvailability, dateVal);
                enable(updateTriggerTarget);
            }
        } else {
            disable(updateTriggerTarget);
        }
    });

    // In the event this function is getting called for more than one page at some point,
    // make sure we only do the below binding if #basicFloorplanDetailsForm exists on the page.
    if (!!document.getElementById('basicFloorplanDetailsForm')) {
        // This function triggers onchange for the select element when the page initially loads,
        // so wait to bind handleFormChange() until after load (otherwise the handleFormChange
        // function will fire without any actual change by the user).
        $availabilitySelect.change(function () {
            handleFormChange('#updateFloorplanBasicDetailsButton');
        });
    }
}

function setupAvailabilityQuestions() {
    var $availabilityQuestions = $('.availabilityQuestion');

    $availabilityQuestions.each(function () {
        setupAvailabilityQuestion($(this));
    });
}

function openInlinePopupContent(target) {
    $.magnificPopup.open({
        items: {
            src: target,
            type: 'inline'
        }
    });
}

jQuery(function ($) {

    initSelect2();

    setupAvailabilityQuestions();
    // Half-second delay (so must be intentionally hovered over)
    $('.tooltip:not(.no-delay):not(.medium-wrap-tooltip)').tooltip({
        show: {delay: TOOLTIP_DELAY}
    });

    // Default delay (0ms)
    $('.tooltip.no-delay:not(.medium-wrap-tooltip)').tooltip();

    // medium tooltip with delay
    $('.tooltip.medium-wrap-tooltip:not(.no-delay)').tooltip({
        tooltipClass: 'ui-tooltip medium-wrap-tooltip',
        show: {delay: TOOLTIP_DELAY}
    });

    // medium tooltip with now delay
    $('.tooltip.medium-wrap-tooltip.no-delay').tooltip(
        {tooltipClass: 'ui-tooltip medium-wrap-tooltip'}
    );

});

function checkSpecialUploadFields() {
    const contentSpecialImage = document.getElementById('specialImage').value;
    const contentSpecialImageAltText = document.getElementById('specialImageAltText').value;
    if (contentSpecialImage && contentSpecialImageAltText.length === 0) {
        alert('Cannot upload a Special Image without a description.');
        $('#specialImageAltText').focus();
        return false;
    } else {
        disable('#updateCommunitySpecialUploadButton');
        return true;
    }
}

function checkSpecialFields() {
    const contentSpecial = tinymce.get('special').getContent();
    const contentSpecialTerms = tinymce.get('specialTerms').getContent();
    let specialExpirationDate = null;
    let specialExpirationId = 'homeSpecialExpiration';
    if (!!document.getElementById('homeSpecialExpiration')) {
        specialExpirationDate = document.getElementById('homeSpecialExpiration').value;
    } else {
        specialExpirationId = 'specialExpiration';
        specialExpirationDate = document.getElementById('specialExpiration').value;
    }
    if (!contentSpecial && !!contentSpecialTerms) {
        alert('Cannot have Special Terms without a Special defined.');
        $('#special').focus();
        return false;
    } else if (!!specialExpirationDate && !contentSpecial) {
        alert('Cannot have a Special Expiration Date without a Special defined.');
        $('#special').focus();
        return false;
    } else if (!!specialExpirationDate && !validDateMMDDYYYYAfterToday(specialExpirationDate)) {
        alert('Please enter a valid Special Expiration Date that is today or later.');
        $('#' + specialExpirationId).focus();
        return false;
    } else {
        disable('#updateCommunityHomePageSpecialContentButton');
        return true;
    }
}

function validDateMMDDYYYY(inputDateString) {
    if (inputDateString.length != 0) {
        let validDate = $.trim(inputDateString);
        let validDateParts = validDate.split('/');
        if (validDateParts.length != 3 || validDateParts[0].length != 2 || validDateParts[1].length != 2 || validDateParts[2].length != 4) {
            return false;
        }
        let validDateObj = new Date(validDateParts[2], validDateParts[0] - 1, validDateParts[1]);
        if (validDateObj.getMonth() + 1 != parseInt(validDateParts[0]) || validDateObj.getDate() != parseInt(validDateParts[1]) || validDateObj.getFullYear() != parseInt(validDateParts[2])) {
            return false;
        }
    }
    return true;
}

function validDateMMDDYYYYAfterToday(inputDateString) {
    if (validDateMMDDYYYY(inputDateString)) {
        let validDateParts = $.trim(inputDateString).split('/');
        let validDateObj = new Date(validDateParts[2], validDateParts[0] - 1, validDateParts[1]);
        let now = new Date();
        let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        if (validDateObj < today) {
            return false;
        }
    }
    return true;
}

function resetDidChangeFields() {
    document.getElementById('specialDidChange').value = 'false';
    document.getElementById('specialTermsDidChange').value = 'false';
    document.getElementById('homeSpecialExpirationDidChange').value = 'false';
    return false;
}

/**
 * Hides one element and shows another.
 * @param {!string} selectorToHide A valid selector for the element to hide (such as '#someId').
 * @param {!string} selectorToShow A valid selector for the element to show (such as '#someId').
 */
function hideShow(selectorToHide, selectorToShow) {
    $(selectorToHide).hide();
    $(selectorToShow).show();
}

/**
 * Submits an asynchronous API request to update either a community or a floorplan special's expiration date.
 */
function updateSpecialExpiration(event) {
    var $submitTriggerElement = $(event.target);
    // Ignore attempts to perform an update if the submit element is "disabled" (meaning an update is already in progress).
    if (!$submitTriggerElement.hasClass('disabled')) {
        // Before the request is fired, "disable" the submit element and change its text to indicate a save is in progress.
        $submitTriggerElement.addClass('disabled');

        var expirationDate = $('#popup-special-date-picker').val();
        if (!validDateMMDDYYYYAfterToday(expirationDate)) {
            $submitTriggerElement.removeClass('disabled');
            alert('Please enter a valid Special Expiration Date that is today or later.');
            $('#popup-special-date-picker').focus();
            return;
        }
        $submitTriggerElement.text('Saving...');

        var type = $('#specialType').val();
        var applicationId = $('#floorplanSpecialApplicationId').val();
        var payload = {
            type: type,
            floorplanId: type === 'floorplan' ? $('#popup-floorplan-id').val() : null,
            applicationId: !!applicationId ? applicationId : null,
            expirationDate: expirationDate,
            userId: $('#floorplanSpecialUserId').val()
        };

        var request = $.ajax({
            url: '/rapi/rvp/update-special-expiration',
            type: 'POST',
            data: JSON.stringify(payload),
            contentType: 'application/json'
        });

        // The request completed successfully.
        request.done(function () {
            $submitTriggerElement.text('Saved!');
            var expirationDateForDisplay = !!expirationDate ? expirationDate : 'N/A';
            $('#current-floorplan-expiration').text(expirationDateForDisplay);
            var existingSpecialExpirationElementId = $('#floorplan-special-popup').data('existingSpecialExpirationElementId');
            if (!!existingSpecialExpirationElementId) $('#' + existingSpecialExpirationElementId).text(expirationDateForDisplay);
            setTimeout(function () {
                $submitTriggerElement.text('Save');
                hideShow('#special-expiration-edit', '#special-expiration-display');
            }, 750);
        });

        // The request failed.
        request.fail(function (request) {
            $submitTriggerElement.text('Save');
            // Use the message from the response, if available; otherwise, fall back to default error verbiage.
            alert(!!request.responseJSON && !!request.responseJSON.message
                ? request.responseJSON.message
                : request.status === 403
                    ? 'There was a problem saving the expiration date, please contact your Client Success Manager.'
                    : 'There was a problem saving the expiration date. Please check that it\'s in the format mm/dd/yyyy and try resubmitting. If this error persists, please contact your Client Success Manager.');
        });

        // The request completed (either successfully or not).
        request.complete(function () {
            // Re-enable the submit element so another save may be fired, if desired.
            $submitTriggerElement.removeClass('disabled');
        });
    }
}

/**
 * This method used to change the visibility of the classification select, but it is now just used to
 * ensure that the dropdown is never hidden. Without doing this, it gets disabled sometimes.
 */
function setCallClassificationSelectVisibility() {
    document.getElementById('filterCallClassification').disabled = false;
}

/**
 * Replaces browser URL's query parameter that corresponds to the passed element's name and value.
 * @param {!HTMLElement} element The Element for the input.
 */
function updateQueryParamsOnInputChange(element) {
    // When the select changes, update the URL query params (does not force refresh unless < IE10).
    replaceQueryParam(element.name, element.value);
}

function filterOnPageLoad() {
    emailSearchDB('#emailSearch', '#clearEmailSearch', '.intro', '.emailFullContent', '#noSearchResults', 'LEAD');
}

function filterLeasesOnPageLoad() {
    emailSearchDB('#emailSearch', '#clearEmailSearch', '.intro', '.emailFullContent', '#noSearchResults', 'LEASES');
}

// TODO: move all below into common-utils

/**
 * Replace the browser's URL without a page reload (unless using fallback). Using the back button
 * will not return the the replaced URL.
 * @param {!string} url
 * @param {boolean} [useFallback=true] Indicates whether a fallback should be used for browsers
 *                    that don't support window.history.replaceStateUrl(). The fallback reloads the page.
 */
function replaceStateUrl(url, useFallback) {
    if (useFallback === undefined) {//IE11 doesn't support default parameters.
        useFallback = true;
    }
    // This is supported in IE10+. https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState#Browser_Compatibility
    if (window.history.replaceState) {
        // Updates the browser's URL with no history (back button will not revert this replacement to what it was before).
        window.history.replaceState({}, document.title, url);
    } else if (useFallback) {
        // This downside to this fallback is that is causes a page reload.
        // This works in all browsers. https://developer.mozilla.org/en-US/docs/Web/API/Location/replace#Browser_compatibility
        window.location.replace(url);
    }
}

/**
 * Replace the browser URL's query string without a page reload (unless using fallback). Using the back button
 * will not return the the replaced URL.
 * @param {!string} queryString A URL query string like '?a=1' or '?a=1&b=2' or '' to clear query string.
 */
function replaceStateQueryString(queryString) {
    replaceStateUrl(window.location.origin + window.location.pathname + (!!queryString ? queryString : ''));
}

/**
 * Update one of the query params in the URL without a page reload (unless < IE10).
 * @param {!string} key The name/key for the parameter.
 * @param {?string} value The value for the parameter. Use `null` or `undefined` or an empty string
 *                    (can leave out, entirely) to remove the parameter.
 */
function replaceQueryParam(key, value) {
    var queryParams = getQueryParams();
    if (queryParams.hasOwnProperty(key) && queryParams[key] === value) return; // If there's no change, don't try to replace state.
    // Matches anything except null or undefined or an empty string.
    if (value != null && value !== '') {
        queryParams[key] = value;
    } else {
        delete queryParams[key];
    }
    replaceStateQueryString(objectToQueryParamString(queryParams));
}

/**
 * Retrieve the query parameters from the URL as an Object where keys are the parameter names
 * and values are the parameter values.
 * @returns {Object}
 */
function getQueryParams() {
    var queryParamString = window.location.search;
    var queryParams = {};
    if (!!queryParamString) {
        queryParamString = queryParamString.substring(1); // Drop off the leading ?
        var paramsArray = queryParamString.split('&');
        for (var i = 0; i < paramsArray.length; i++) {
            var keyValuePair = paramsArray[i].split('=');
            queryParams[keyValuePair[0]] = keyValuePair[1];
        }
    }
    return queryParams;
}

/**
 * Converts an Object to a query parameter string where the Object's keys are the parameter names
 * and the values are the parameter values.
 * @example
 * const params = {a: 7, b: 'hello'};
 * objectToQueryParamString(); // results in --> ?a=7&b=hello
 * @param queryParamsObject
 * @returns {string}
 */
function objectToQueryParamString(queryParamsObject) {
    var keys = Object.keys(queryParamsObject);
    var queryParamString = '';
    if (keys.length > 0) {
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (i === 0) {
                queryParamString += '?' + key + '=' + queryParamsObject[key];
            } else {
                queryParamString += '&' + key + '=' + queryParamsObject[key];
            }
        }
    }
    return queryParamString;
}

/**
 * Tries the set the value to '' for all elements selected by the list of query selectors passed in.
 * @param {!string[]} inputSelectors An array of strings that are valid query selector's such as '#someElementId'
 *                    (should be such that only one element would be found that matches).
 */
function clearValues(inputSelectors) {
    if (!!inputSelectors && inputSelectors.length > 0) {
        for (var i = 0; i < inputSelectors.length; i++) {
            var input = document.querySelector(inputSelectors[i]);
            if (!!input && !!input.value) {
                input.value = '';
            }
        }
    }
}

/**
 * Finds all elements on the page by name and update's their values and then replaces the corresponding URL query param.
 * @param {!string} name The element(s)'s name attribute.
 * @param {?string|boolean|number} value The new value that should replace the element's current value.
 */
function replaceValueAndQueryParam(name, value) {
    value = (!!value || value === false || value === 0) ? value : '';
    var inputElements = document.getElementsByName(name);
    // If for some reason there are multiple elements with the same name, update all of them.
    // In most cases, there should only be one (which will still work with this implementation).
    if (inputElements.length > 0) {
        for (var i = 0; i < inputElements.length; i++) {
            inputElements[i].value = value;
        }
    }
    replaceQueryParam(name, value);
}

function toggleEmailIsSpam(emailTrackingId) {
    const isSpam = $('#spamEmailToggle' + emailTrackingId).is(':checked');
    const request = $.ajax({
        url: '/rapi/rvp/email/update-email-is-spam?eti=' + emailTrackingId + '&spam=' + isSpam,
        type: 'PUT',
        dataType: 'text',
        success: function (data, textStatus, XmlHttpRequest) {
            trackEvent('Mark as Spam', isSpam.toString(), emailTrackingId);
            if (isSpam) {
                $('#spamAlert' + emailTrackingId).show();
                $('#spamEmailToggleLabel' + emailTrackingId).text('Unmark Email as Spam');
            } else {
                $('#spamAlert' + emailTrackingId).hide();
                $('#spamEmailToggleLabel' + emailTrackingId).text('Mark Email as Spam');
            }
        }
    });
    request.fail(function () {
        $('#spamEmailToggle' + emailTrackingId).prop('checked', !isSpam); // Revert checkbox state if update fails
        if (jqXHR.responseJSON && jqXHR.responseJSON.message) { // make sure there is a response json and that it has a message
            alert(jqXHR.responseJSON.message);
        } else {
            alert('An error occurred while ' + (isSpam ? 'marking' : 'unmarking') + ' the email as spam. Please try again.');
        }
    });
}

function parseColor(color) {
    // If the color is in hex format (e.g., "#FFFFFF" or "#FFF")
    if (color.startsWith('#')) {
        return hexToRgb(color);
    }
    // If the color is in RGB or RGBA format (e.g., "rgb(255, 255, 255)" or "rgba(255, 255, 255, 1)")
    else if (color.startsWith('rgb')) {
        return rgbStringToArray(color);
    }
    // Return null for unsupported formats
    return null;
}

function hexToRgb(hex) {
    // Handle shorthand hex format (e.g., "#FFF")
    if (hex.length === 4) {
        hex = '#' + [...hex.slice(1)].map(x => x + x).join('');
    }

    // Convert hex to RGB
    let bigint = parseInt(hex.slice(1), 16);
    let r = (bigint >> 16) & 255;
    let g = (bigint >> 8) & 255;
    let b = bigint & 255;

    return [r, g, b];
}

function rgbStringToArray(rgbString) {
    // Extract the numeric values from the RGB/RGBA string
    let values = rgbString.match(/\d+(\.\d+)?/g).map(Number);

    // If RGBA, we ignore the alpha value for contrast calculations
    return values.slice(0, 3);
}

function luminance([r, g, b]) {
    // Normalize RGB values to 0-1
    let a = [r, g, b].map(function (v) {
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    });

    // Calculate luminance
    return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2];
}

function contrastRatio(color1, color2) {
    // Parse the colors
    let rgb1 = parseColor(color1);
    let rgb2 = parseColor(color2);

    if (!rgb1 || !rgb2) {
        throw new Error('Invalid color format. Please use hex, rgb, or rgba.');
    }

    // Calculate luminance for both colors
    let lum1 = luminance(rgb1);
    let lum2 = luminance(rgb2);

    // Calculate contrast ratio
    let brightest = Math.max(lum1, lum2);
    let darkest = Math.min(lum1, lum2);

    return (brightest + 0.05) / (darkest + 0.05);
}